import React, { Component } from 'react';
import "./PeriodicalsOrJournals.css";
import { connect } from 'react-redux';
import LibraryApiCall from 'LibraryApiCall';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import { logDOM } from '@testing-library/react';
import { default as ReactSelect, components, InputProps } from "react-select";
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import Pagination from 'react-js-pagination';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import DeleteModal from 'LIBRARY/CommonResources/DeleteModal/DeleteModal';
import ImportPeriodicals from 'LIBRARY/Components/Periodicals/PeriodicalsOrJournals/importPeriodicals/importPeriodicals.js';
import ImportSubscription from './ImportSubscription/ImportSubscription';
import Select from 'react-select';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import { toast } from 'react-toastify';
import SpecificUserLog from 'LIBRARY/CommonResources/SpecificUserLog/SpecificUserLog';

let selectedCheckboxIID = []

class PeriodicalJournal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addPeriodical: false,
            addCategoryModal: false,
            totalPrice: '0',
            subscriptions: [
                {
                    id: 1,
                    vendor: '',
                    startDate: '',
                    startDateWarning: '',
                    endDate: '',
                    endDateWarning: '',
                    expectedIssues: '',
                    avgPricePerCopy: '',
                    subUniqueid: '',
                    addOrUpdateKey: '',
                    mandatoryWarning: ''
                }
            ],
            periodicalCategoryList: {},
            periodicalCategoryListLoading: false,
            periodicalCategory: '',
            editingCategoryId: null,
            editedCategoryName: '',
            successModal: false,

            vendorList: {},
            GetPublisherList: {},
            loadingPublisherData: false,
            searchPublisher: '',

            // VARIABLES TO EXPORT PERODICALS
            exportDetails: false,

            categoryFilter: '',
            periodicalTitleFilter: '',
            periodicityFilter: '',
            iidFilter: config.institute_id,

            // VARIABLES TO DELETE periodicals
            deletePeriodical: false,

            // States for add/edit periodicals
            selectedCategory: '',
            selectedDepartmentObject: '',
            selectedDepartment: '',
            departmentList: [],
            departments: {},
            periodicalTitle: '',
            periodicalTitleWarning: '',
            publisherName: '',
            issnNumber: '',
            selectedPeriodicity: '',
            editPeriodicalUID: '',

            // States to update Subscriptions
            updateSubcriptionModal: false,
            priodicalTitleForModal: '',
            periodicalUniqueIdofSub: '',
            periodicalUIDToDeletePeriodical: '',
            selectedPeriodicalds: [],

            periodicalListLoading: false,
            periodicalAllData: {},
            sortedIdArray: [],
            totalRecords: '',
            periodicalDeleteStatus: 'active',

            offset: 0,
            pageIndex: 1,
            limit: 10,

            // States to edit periodical
            isEditPeriodical: false,

            isShowImportPeriodicalButton: false,
            isShowImportSubscriptionButton: false,


            // VARIABLES TO GET ACCESSION SERIES
            accessionSeriesList: {},
            accessionSeriesLoading: false,
            AccessionSeries: '',
            AccessionNumber: '',
            GetMaximumLibraryAccessionValue: '',
            loadingGetMaximumLibraryAccession: false,
            accessError: '',
            dataHideWhileExporting: true,

            // temp filter state
            periodicalTitleFilterTemp: "",
            categoryFilterTemp: "",
            periodicityFilterTemp: "",
            statusFilterTemp: "active",
            iidFilterTemp: config.institute_id,

            multipleInstituteDetails: this.props.multipleInstituteDetails.multipleInstituteDetails || {},

            addPeriodicalInstituteIID: [{
                value: config.institute_id,
                label: this.props?.multipleInstituteDetails?.multipleInstituteDetails?.[config.institute_id]?.institute_name || ''
            }],

            // add periodical
            loadingAddPublisher: false,
            addPublisherData: [],
            loadingAddAccessionSeries: false,
            addAccessionSeriesData: [],
            loadingAddCategory: false,
            addCategoryData: [],
            loadingAddDepartment: false,
            addDepartmentData: [],
            loadingAddVendor: false,
            addVendorData: [],

            // edit peridoical
            loadingEditPublisher: false,
            editPublisherData: [],
            currentEditPublisherIds: [],
            loadingEditAccessionSeries: false,
            editAccessionSeriesData: [],
            loadingEditCategory: false,
            editCategoryData: [],
            loadingEditDepartment: false,
            editDepartmentData: [],

            editPeriodicalIID: config.institute_id,
            resourceCategoryIID: [{
                value: config.institute_id,
                label: this.props?.multipleInstituteDetails?.multipleInstituteDetails?.[config.institute_id]?.institute_name || ''
            }],
            categoryDetails: '',

            filterPeriodicalCategoryData: [],
            periodicalSearchIID: config.institute_id,

            loadingAddSubVendor: false,
            addSubVendorData: [],

            showActivitySlider: false,
            selectedIid:"",
            hoverID:"",
        }
    }

    componentDidMount() {
        this.getPeriodicalCategoryList();
        this.GetInstituteStreamsObject();
        this.calculateTotalPrice();
        this.getVendorDetailsList();
        this.getPeriodicalList();
        this.getPublisherList();
        this.apiCallToGetAccessionSeries(); // accession series

        // add periodical
        this.getAddPublisherList();
        this.getAddAccessionSeries();
        this.getAddCategory();
        this.getAddDepartment();
        this.getAddVendor();

        // add subscription
        this.getAddSubVendorData();

        // filter 
        this.filterGetPeriodicalCategoryList();
    }

    // Add subscription data
    getAddSubVendorData = async () => {
        this.setState({
            loadingAddSubVendor: true
        });

        let requestData = {
            "iid": this.state.editPeriodicalIID,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getVendorDetailsList',
            requestData,
            "/api/instructor/accountingManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getAddSubVendorData();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        addSubVendorData: apiResult.data,
                        loading: false
                    })
                }
                else {
                    this.setState({
                        addSubVendorData: [],
                        loadingAddSubVendor: false
                    })
                }
            } else {
                this.setState({
                    addSubVendorData: [],
                    loadingAddSubVendor: false
                })
            }
        }
    }

    filterGetPeriodicalCategoryList = async () => {

        let multipleInstistuteStreamValue = Array.isArray(this.state.periodicalSearchIID)
            ? this.state.periodicalSearchIID
            : [this.state.periodicalSearchIID];

        let requestData = {
            "iidArray": multipleInstistuteStreamValue
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryPeriodicalCategoryList',
            requestData,
            '/api/library/library.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.filterGetPeriodicalCategoryList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    filterPeriodicalCategoryData: apiResult,
                });
            }
        }
    }

    //**** Add Periodical API Call based selected institute START */
    // API CALL TO GET get publisher List 
    getAddPublisherList = async () => {
        this.setState({
            loadingAddPublisher: true,
        })

        let addPeriodicalIID = '';
        if (this.state.addPeriodicalInstituteIID.length > 0) {
            addPeriodicalIID = this.state.addPeriodicalInstituteIID[0].value
        } else {
            addPeriodicalIID = this.state.addPeriodicalInstituteIID.value
        }

        let requestData = {
            iid: addPeriodicalIID,
            // isOrderByAscendingDisplayName: "true",
            pageIndex: "all",
            limitPerPage: "all",
            searchPublisher: this.state.searchPublisher
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPublisherList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getAddPublisherList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const publisherData = apiResult?.data || {};
                const sortedIdArray = Array.isArray(apiResult?.sortedIdArray) ? apiResult.sortedIdArray : [];

                const formattedData = (sortedIdArray.length > 0
                    ? sortedIdArray
                        .filter((publisherId) => publisherData[publisherId])
                        .map((publisherId) => ({
                            value: publisherId,
                            label: publisherData[publisherId]?.name,
                        }))
                    : Object.entries(publisherData).map(([publisherId, publisherInfo]) => ({
                        value: publisherId,
                        label: publisherInfo?.name,
                    }))
                );

                this.setState({
                    addPublisherData: formattedData,
                    loadingAddPublisher: false,
                })
            } else {
                this.setState({
                    loadingAddPublisher: false,
                })
            }
        }
    }

    //API CALL METHOD TO GET ACCESSION SERIES
    getAddAccessionSeries = async () => {
        this.setState({ loadingAddAccessionSeries: true });

        let addPeriodicalIID = '';
        if (this.state.addPeriodicalInstituteIID.length > 0) {
            addPeriodicalIID = this.state.addPeriodicalInstituteIID[0].value
        } else {
            addPeriodicalIID = this.state.addPeriodicalInstituteIID.value
        }

        let requestData = {
            "iid": addPeriodicalIID,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getAddAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    label: seriesData?.seriestext,
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    addAccessionSeriesData: formattedMembers,
                    loadingAddAccessionSeries: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingAddAccessionSeries: false
                });
            }
        }
    }

    // API CALL METHOD TO GET DEPARTMENT LIST
    getAddCategory = async () => {
        this.setState({
            loadingAddCategory: true
        });

        let addPeriodicalIID = '';
        if (this.state.addPeriodicalInstituteIID.length > 0) {
            addPeriodicalIID = this.state.addPeriodicalInstituteIID[0].value
        } else {
            addPeriodicalIID = this.state.addPeriodicalInstituteIID.value
        }

        let requestData = {
            "iid": addPeriodicalIID,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryPeriodicalCategoryList',
            requestData,
            '/api/library/library.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getAddCategory();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    addCategoryData: apiResult,
                    loadingAddCategory: false
                });

                this.props.categoryList(apiResult);

            }
        }
    }

    // API CALL TO GET FACULTY STREAM DATA LIST
    getAddDepartment = async () => {
        this.setState({
            loadingAddDepartment: true
        });

        let addPeriodicalIID = '';
        if (this.state.addPeriodicalInstituteIID.length > 0) {
            addPeriodicalIID = this.state.addPeriodicalInstituteIID[0].value
        } else {
            addPeriodicalIID = this.state.addPeriodicalInstituteIID.value
        }

        let requestData = {
            "iid": addPeriodicalIID,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            "/api/admission/streamManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getAddDepartment();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                        value: seriesId,
                        label: seriesData?.stream_name,
                    }));

                    this.setState({
                        addDepartmentData: formattedData,
                        loadingAddDepartment: false
                    })
                }
                else {
                    this.setState({
                        addDepartmentData: [],
                        loadingAddDepartment: false
                    })
                }
            } else {
                this.setState({
                    addDepartmentData: [],
                    loadingAddDepartment: false
                })
            }
        }
    }

    // API CALL TO GET FACULTY STREAM DATA LIST
    getAddVendor = async () => {
        this.setState({
            loadingAddVendor: true
        });

        let addPeriodicalIID = '';
        if (this.state.addPeriodicalInstituteIID.length > 0) {
            addPeriodicalIID = this.state.addPeriodicalInstituteIID[0].value
        } else {
            addPeriodicalIID = this.state.addPeriodicalInstituteIID.value
        }

        let requestData = {
            "iid": addPeriodicalIID,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getVendorDetailsList',
            requestData,
            "/api/instructor/accountingManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getAddVendor();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        addVendorData: apiResult.data,
                        loadingAddVendor: false
                    })
                }
                else {
                    this.setState({
                        addVendorData: [],
                        loadingAddVendor: false
                    })
                }
            } else {
                this.setState({
                    addVendorData: [],
                    loadingAddVendor: false
                })
            }
        }
    }

    //**** Add Periodical API Call based selected institute END */

    //**** EDIT Periodical API Call based selected institute START */
    // API CALL TO GET get publisher List 
    getEditPublisherList = async () => {
        this.setState({
            loadingEditPublisher: true,
        })

        let requestData = {
            iid: this.state.editPeriodicalIID,
            // isOrderByAscendingDisplayName: "true",
            pageIndex: "all",
            limitPerPage: "all",
            searchPublisher: this.state.searchPublisher
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPublisherList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getAddPublisherList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const publisherData = apiResult?.data || {};
                const sortedIdArray = Array.isArray(apiResult?.sortedIdArray) ? apiResult.sortedIdArray : [];

                const formattedData = (sortedIdArray.length > 0
                    ? sortedIdArray
                        .filter((publisherId) => publisherData[publisherId])
                        .map((publisherId) => ({
                            value: publisherId,
                            label: publisherData[publisherId]?.name,
                        }))
                    : Object.entries(publisherData).map(([publisherId, publisherInfo]) => ({
                        value: publisherId,
                        label: publisherInfo?.name,
                    }))
                );

                this.setState({
                    editPublisherData: formattedData,
                    loadingEditPublisher: false,
                }, () => {
                    if (this.state.isEditPeriodical && this.state.currentEditPublisherIds.length > 0) {
                        const normalizedPublisherIds = this.state.currentEditPublisherIds.map(String);
                        const selectedPublisher = formattedData.filter(publisher =>
                            normalizedPublisherIds.includes(String(publisher.value))
                        );

                        if (selectedPublisher.length > 0) {
                            this.setState({ publisherName: selectedPublisher });
                        }
                    }
                })
            } else {
                this.setState({
                    loadingEditPublisher: false,
                })
            }
        }
    }

    //API CALL METHOD TO GET ACCESSION SERIES
    getEditAccessionSeries = async () => {
        this.setState({ loadingEditAccessionSeries: true });

        let requestData = {
            "iid": this.state.editPeriodicalIID,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getAddAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    label: seriesData?.seriestext,
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    editAccessionSeriesData: formattedMembers,
                    loadingEditAccessionSeries: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingEditAccessionSeries: false
                });
            }
        }
    }

    // API CALL METHOD TO GET DEPARTMENT LIST
    getEditCategory = async () => {
        this.setState({
            loadingEditCategory: true
        });

        let requestData = {
            "iid": this.state.editPeriodicalIID,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryPeriodicalCategoryList',
            requestData,
            '/api/library/library.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getEditCategory();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    editCategoryData: apiResult,
                    loadingEditCategory: false
                });
            }
        }
    }

    // API CALL TO GET FACULTY STREAM DATA LIST
    getEditDepartment = async () => {
        this.setState({
            loadingEditDepartment: true
        });

        let requestData = {
            "iid": this.state.editPeriodicalIID,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            "/api/admission/streamManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getAddDepartment();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                        value: seriesId,
                        label: seriesData?.stream_name,
                    }));

                    this.setState({
                        editDepartmentData: formattedData,
                        loadingEditDepartment: false
                    })
                }
                else {
                    this.setState({
                        addDepartmentData: [],
                        loadingEditDepartment: false
                    })
                }
            } else {
                this.setState({
                    addDepartmentData: [],
                    loadingEditDepartment: false
                })
            }
        }
    }

    //**** EDIT Periodical API Call based selected institute END */


    //**** Periodical List API Call based selected institute START */

    //API CALL METHOD TO GET ACCESSION SERIES
    apiCallToGetAccessionSeries = async () => {
        this.setState({ accessionSeriesLoading: true });

        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                if (Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(seriesId => {
                        apiResult[seriesId]['seriesId'] = seriesId;
                    });
                }

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesData.seriesId, // Use `faculty_id` as the value
                    label: seriesData?.seriestext, // Display name
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    accessionSeriesList: formattedMembers,
                    accessionSeriesLoading: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    accessionSeriesLoading: false
                });
            }
        }
    }

    // API CALL METHOD TO GET PERIODICAL LIST
    getPeriodicalList = async () => {

        this.setState({
            periodicalListLoading: true,
        });

        let requestData = {
            "iid": config.institute_id,
            "pageIndex": this.state.pageIndex,
            "limitPerPage": this.state.limit,
            "filterData": {
                "title": this.state.periodicalTitleFilter,
                "periodicity": this.state.periodicityFilter,
                "periodical_category_id": this.state.categoryFilter,
                "filteredIID": this.state.iidFilter
            },
            "status": this.state.periodicalDeleteStatus,
            "iidArray": this.props.iidArray.iidArray
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPeriodicalList',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getPeriodicalList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                this.setState({
                    periodicalAllData: apiResult.data,
                    totalRecords: apiResult.totalRecords,
                    sortedIdArray: apiResult.sortedIdArray,
                    periodicalListLoading: false
                });
            }
        }
    }

    // API CALL TO GET get publisher List 
    getPublisherList = async () => {
        this.setState({
            loadingPublisherData: true,
        })
        let requestData = {
            iid: config.institute_id,
            // isOrderByAscendingDisplayName: "true",
            pageIndex: "all",
            limitPerPage: "all",
            searchPublisher: this.state.searchPublisher
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPublisherList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getPublisherList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const publisherData = apiResult?.data || {};
                const sortedIdArray = Array.isArray(apiResult?.sortedIdArray) ? apiResult.sortedIdArray : [];

                const formattedData = (sortedIdArray.length > 0
                    ? sortedIdArray
                        .filter((publisherId) => publisherData[publisherId])
                        .map((publisherId) => ({
                            value: publisherId,
                            label: publisherData[publisherId]?.name,
                        }))
                    : Object.entries(publisherData).map(([publisherId, publisherInfo]) => ({
                        value: publisherId,
                        label: publisherInfo?.name,
                    }))
                );

                this.setState({
                    GetPublisherList: formattedData,
                    loadingPublisherData: false,
                })
            } else {
                this.setState({
                    loadingPublisherData: false,
                })
            }
        }
    }

    // Method called to get total price
    calculateTotalPrice = () => {
        const totalPrice = this.state.subscriptions.reduce((total, subscription) => {

            if (subscription.expectedIssues == '' || subscription.expectedIssues == 0) {
                return total;

            } else {

                return total + (subscription.expectedIssues * subscription.avgPricePerCopy);
            }
        }, 0);
        this.setState({ totalPrice });
    }

    // API CALL TO GET FACULTY STREAM DATA LIST
    GetInstituteStreamsObject = async () => {

        let requestData = {
            "iid": config.institute_id,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            "/api/admission/streamManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstituteStreamsObject();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.departmentList(apiResult.data)

                    this.setState({
                        departments: apiResult.data,
                    })
                }
                else {
                    this.setState({
                        departmentList: [],
                        departments: {}
                    })
                }
            } else {
                this.setState({
                    departmentList: [],
                    departments: {}
                })
            }
        }
    }

    // API CALL TO GET FACULTY STREAM DATA LIST
    getVendorDetailsList = async () => {

        let requestData = {
            "iid": config.institute_id,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getVendorDetailsList',
            requestData,
            "/api/instructor/accountingManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getVendorDetailsList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        vendorList: apiResult.data,
                    })
                }
                else {
                    this.setState({
                        vendorList: {}
                    })
                }
            } else {
                this.setState({
                    vendorList: {}
                })
            }
        }
    }

    // METHODS TO SET STATES
    departmentList = (departmentData) => {
        let departmentList = [];
        Object.keys(departmentData).map((keys, index) => {
            let department = departmentData[keys]
            let options = { "value": keys, "label": department.stream_name };
            departmentList.push(options);
        })
        this.setState({
            departmentList: departmentList,
        })
    }

    selectDepartments = (selectedOption) => {
        let selectDepartment = this.state.selectedDepartment;
        selectDepartment = [];

        if (selectedOption.length > 0) {
            selectedOption.map(option => {
                if (!selectDepartment.includes(option.value)) {
                    selectDepartment.push(option.value);
                }
            })
        }
        this.setState({
            selectedDepartment: selectDepartment
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    // API CALL METHOD TO GET DEPARTMENT LIST
    getPeriodicalCategoryList = async () => {

        this.setState({
            periodicalCategoryListLoading: true
        });

        let requestData = {
            "iid": config.institute_id,
            "iidArray": this.props.iidArray.iidArray
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryPeriodicalCategoryList',
            requestData,
            '/api/library/library.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getPeriodicalCategoryList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    periodicalCategoryList: apiResult,
                    periodicalCategoryListLoading: false
                });

                this.props.categoryList(apiResult);

            }
        }
    }

    // API CALL METHOD TO ADD CATEGORY
    apiCallToAddPeriodicalCategory = async () => {

        const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['periodicals'].find(access => access === 'add');

        let addCategoryIID = '';
        if (this.state.resourceCategoryIID.length > 0) {
            addCategoryIID = this.state.resourceCategoryIID[0].value
        } else {
            addCategoryIID = this.state.resourceCategoryIID.value
        }

        if (addGrantAccess !== undefined) {
            let requestData = {
                "iid": addCategoryIID, // config.institute_id,
                "facultyId": config.faculty_id,
                "category_name": this.state.periodicalCategory,
                "uniqueId": 1
            };

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'AddLibraryPeriodicalCategory',
                requestData,
                '/api/library/library.php'
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToAddPeriodicalCategory()
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;

                    if (apiResult.status == 'success') {

                        this.setState({
                            successModal: true,
                            successModalType: 'success',
                            successMessage: ReactHtmlParser(apiResult.message),
                        }, () => { this.setState({ periodicalCategory: '' }); this.getPeriodicalCategoryList() });
                    } else {
                        this.setState({
                            successModal: true,
                            successModalType: 'warning',
                            successMessage: apiResult.message,
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while adding category. Please try again later.',
                    });
                }
            }

        } else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // API CALL METHOD TO UPDATE CATEGORY
    apiCallToUpdatePeriodicalCategory = async () => {
        const editGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['periodicals'].find(access => access === 'edit');

        let categoryIID = this.state.categoryDetails?.periodicalCategoryIID

        if (editGrantAccess !== undefined) {

            let requestData = {
                "iid": categoryIID, //config.institute_id,
                "facultyId": config.faculty_id,
                "category_name": this.state.editedCategoryName,
                "uniqueId": this.state.editingCategoryId
            };

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'UpdateLibraryPeriodicalCategory',
                requestData,
                '/api/library/library.php'
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToUpdatePeriodicalCategory()
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;
                    if (apiResult.status == 'success') {
                        this.setState({
                            successModal: true,
                            successModalType: 'success',
                            successMessage: ReactHtmlParser(apiResult.message),
                            editingCategoryId: ''
                        }, () => this.getPeriodicalCategoryList());
                    } else {
                        this.setState({
                            successModal: true,
                            successModalType: 'warning',
                            successMessage: apiResult.message,
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while updating category. Please try again later.',
                    });
                }
            }
        } else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO DELETE PERIODICAL CATEGORY
    deletePeriodicalCategory = async (categoryId, categoryIid) => {

        const deleteGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['periodicals'].find(access => access === 'delete');

        let categoryIID = categoryIid

        if (deleteGrantAccess !== undefined) {

            let requestData = {
                "iid": categoryIID, //config.institute_id,
                "uniqueId": categoryId,
                "facultyId": config.faculty_id
            };

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'DeleteLibraryPeriodicalCategory',
                requestData,
                '/api/library/library.php'
            );
            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.deletePeriodicalCategory()
                }, 1000);
            } else {
                if (jsonResponse.success) {

                    let apiResult = jsonResponse.APIResult;

                    if (apiResult.status == "success") {

                        this.setState({
                            successModal: true,
                            successModalType: 'success',
                            successMessage: apiResult.message,
                        }, () => this.getPeriodicalCategoryList());
                    } else {
                        this.setState({
                            successModal: true,
                            successModalType: 'warning',
                            successMessage: apiResult.message
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while deleting category. Please try again later.'
                    });
                }
            }
        } else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // Method called to close Subcription Modal 
    closeUpdateSubcriptionModal = () => {
        this.setState({
            updateSubcriptionModal: false,
            priodicalTitleForModal: '',
            periodicalUniqueIdofSub: '',
            subscriptions: [
                {
                    id: 1,
                    vendor: '',
                    startDate: '',
                    startDateWarning: '',
                    endDate: '',
                    endDateWarning: '',
                    expectedIssues: '',
                    avgPricePerCopy: '',
                    subUniqueid: '',
                    addOrUpdateKey: ''
                }
            ],
            totalPrice: '0',
        })
    }

    // API CALL METHOD TO PERIODICALS
    apiCallToAddPeriodicals = async () => {
        let publisherIdArray = [];
        if (this.state.publisherName) {
            this.state.publisherName?.map((item) => {
                publisherIdArray.push(item.value)
            })
        } else {
            publisherIdArray = []
        }

        let addPeriodicalIID = '';
        if (this.state.addPeriodicalInstituteIID.length > 0) {
            addPeriodicalIID = this.state.addPeriodicalInstituteIID[0].value
        } else {
            addPeriodicalIID = this.state.addPeriodicalInstituteIID.value
        }

        let requestData = {
            "iid": addPeriodicalIID, // config.institute_id,
            "facultyId": config.faculty_id,
            "title": this.state.periodicalTitle.trim(),
            "publisherName": publisherIdArray, //this.state.publisherName,
            "periodical_category_id": this.state.selectedCategory,
            "periodicity": this.state.selectedPeriodicity,
            "ISSN": this.state.issnNumber,
            "streams": this.state.selectedDepartment == '' ? [] : this.state.selectedDepartment,
            "subscriptionArray": this.state.subscriptions,
            "accessionSeriesId": this.state.AccessionSeries ? this.state.AccessionSeries.value : "",
            "accessionNumber": this.state.AccessionNumber
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_AddPeriodicalsDetails',
            requestData,
            '/api/library/libraryPeriodicals.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToAddPeriodicals()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == 'success') {
                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                    });

                    this.getPeriodicalList();
                    this.closeAddPeriodical();
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while adding periodical. Please try again later.',
                });
            }
        }
    }

    // METHOD TO DELETE PERIODICALS
    apiCallToDeletePeriodical = async (status) => {

        let requestData = {
            "iid": selectedCheckboxIID?.length > 0 ? selectedCheckboxIID[0] : config.institute_id,
            // "unique_idArray": [this.state.periodicalUIDToDeletePeriodical],
            "unique_idArray": this.state.selectedPeriodicalds,
            "facultyId": config.faculty_id,
            "status": status
        };
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_DeletePeriodicalsDetails',
            requestData,
            '/api/library/libraryPeriodicals.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToDeletePeriodical()
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == "success") {

                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                    });
                    this.closeDeletePeriodical();
                    this.getPeriodicalList();

                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while deleting periodical. Please try again later.'
                });
            }
        }
    }

    // This function is used to accession number increment
    incrementLeadingZeroNumber = (leadingZeroString, amountToIncrement) => {
        var amountOfZerosToAdd = leadingZeroString.length;
        var stringToNumber = (+leadingZeroString);
        var zerosToAdd = new Array(amountOfZerosToAdd + 1).join('0');

        var zerosAndNewNumber = zerosToAdd + (stringToNumber + amountToIncrement)
        var amountToSlice = (-1 * amountOfZerosToAdd)
        var newString = zerosAndNewNumber.slice(amountToSlice)
        return newString
    }

    incrementAlphanumericAccessionNumber = (str) => {
        str = str.toString();
        const match = str.match(/(\d+)$/); // Match trailing number, if any

        // Simulate incrementLeadingZeroNumber
        const incrementLeadingZeroNumber = (numStr, incrementBy) => {
            const incremented = (parseInt(numStr, 10) + incrementBy).toString();
            return numStr.length > incremented.length
                ? '0'.repeat(numStr.length - incremented.length) + incremented
                : incremented;
        };

        if (match) {
            const numPart = match[0];
            const strPart = str.slice(0, str.lastIndexOf(numPart));
            return strPart + incrementLeadingZeroNumber(numPart, 1);
        } else {
            // No numeric suffix: just append "1"
            return str + "1";
        }

        // str = str.toString();
        // const numPart = str.match(/([0-9])+$|([0-9]+)$/)[0];
        // const strPart = str.slice(0, str.indexOf(numPart));
        // const isLastIndexNine = numPart.match(/9$/);

        // let incrementedNumber = '';
        // // If we have a leading zero (e.g. - 'L100A099') 
        // // or there is no prefix - we should just increment the number
        // if (isLastIndexNine || strPart != null) {
        //     incrementedNumber = strPart + numPart.replace(/\d+$/, (n) => this.incrementLeadingZeroNumber(n, 1));
        // }
        // // Increment the number and add the missing zero
        // else {
        //     incrementedNumber = strPart + '0' + numPart.replace(/\d+$/, (n) => ++n);
        // }
        // return incrementedNumber;
    }

    GetMaximumLibraryAccession = async (from) => {
        this.setState({
            loadingGetMaximumLibraryAccession: true,
        })
        let requestData = {
            iid: config.institute_id,
            accesseriesid: this.state.AccessionSeries.uniqueId
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetMaximumLibraryAccession',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetMaximumLibraryAccession();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetMaximumLibraryAccessionValue: apiResult.data,
                    loadingGetMaximumLibraryAccession: false,
                })
                if (this.state.GetMaximumLibraryAccessionValue == null) {
                    this.state.GetMaximumLibraryAccessionValue = 1;
                }
                else {
                    // this function is used to accession number increment
                    this.state.GetMaximumLibraryAccessionValue = this.incrementAlphanumericAccessionNumber(this.state.GetMaximumLibraryAccessionValue);
                }
                this.setState({ AccessionNumber: this.state.GetMaximumLibraryAccessionValue, accessError: "Accession number from " + this.state.GetMaximumLibraryAccessionValue + " to " + this.state.GetMaximumLibraryAccessionValue })
            } else {
                this.setState({
                    loadingGetMaximumLibraryAccession: false,
                })
            }
        }
    }

    //function to check accession number 00
    checkAccessionNumber = async (source, from) => {
        let Accessseriesid = "";
        //for add source
        Accessseriesid = this.state.AccessionSeries.uniqueId

        if (source) {
            if (this.state.AccessionSeries != "") {
                //create an array containing accession numbers
                let accessionNo = ""
                accessionNo = this.state.AccessionNumber;

                if (accessionNo != "") {
                    //check if accession no positive integer
                    if (accessionNo != 0) {
                        accessionNo = accessionNo.toString();

                        const match = accessionNo.match(/(\d+)$/); // Find trailing digits
                        let numPart = '0';
                        let strPart = accessionNo;

                        if (match) {
                            numPart = match[0];
                            strPart = accessionNo.slice(0, accessionNo.lastIndexOf(numPart));
                        }

                        const isLastIndexNine = numPart.endsWith('9');

                        let AccessionNumberArray = [];
                        if (isLastIndexNine || strPart != null) {
                            accessionNo = parseInt(numPart, 10);
                            AccessionNumberArray = [accessionNo];
                        } else {
                            accessionNo = parseInt(accessionNo, 10);
                            AccessionNumberArray = [accessionNo];
                        }

                        // const numPart = accessionNo?.match(/([0-9])+$|([0-9]+)$/)[0];
                        // const strPart = accessionNo?.slice(0, accessionNo.indexOf(numPart));
                        // const isLastIndexNine = numPart.match(/9$/);


                        // let AccessionNumberArray = [];
                        // // If Accession Number MM00001
                        // if (isLastIndexNine || strPart != null) {
                        //     accessionNo = parseInt(numPart);
                        //     AccessionNumberArray = [accessionNo];
                        // }
                        // else // accession number 1
                        // {
                        //     accessionNo = parseInt(accessionNo);
                        //     AccessionNumberArray = [accessionNo];
                        // }

                        //code to create accession series id array
                        let accessionsertiesidArray = [Accessseriesid];

                        let extraParam = {
                            source: source,
                            from: from,
                            AccessionNumberArray: AccessionNumberArray
                        }

                        let requestData = {
                            iid: config.institute_id,
                            accessionNoArray: AccessionNumberArray,
                            seriesIdArray: accessionsertiesidArray
                        };

                        let jsonResponse = await LibraryApiCall.makeApiCall(
                            "checkAccessionNumber",
                            requestData,
                            "/api/library/instructor.php"
                        );

                        if (jsonResponse.success) {
                            let apiResult = jsonResponse.APIResult;
                            if (apiResult["status"] == "fail") {
                                this.setState({ accessError: "Accession number is already assigned to other resource.Kindly change accession number." })
                            }
                            else {
                                this.setState({ accessError: "Accession number from " + AccessionNumberArray[0] + " to " + (AccessionNumberArray[AccessionNumberArray.length - 1]) })
                            }
                        }
                    }
                    else {
                        this.setState({ accessError: "Invalid accession number.", AccessionNumber: '' })
                    }
                }
            }
            else {
                this.setState({ accessError: "Kindly select accession series.", AccessionNumber: '' })
            }
        } else {
            this.setState({ accessError: "Kindly enter accession number." })
        }
    }

    // METHOD TO RETURN ADD PERIODICAL
    returnAddPeriodical = () => {
        const customStyles = {
            option: (provided) => ({
                ...provided,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%',
                fontSize: '10px'
            }),
        };
        return (
            <div id="addPeriodicalSideMenu" style={{ display: this.state.addPeriodical ? 'flex' : 'none' }}>
                <div id="addPeriodicalsDataContainer">
                    <div className="row pt-4 pb-3 pl-2">
                        <h5 className="col-11">{this.state.isEditPeriodical ? 'Update Periodicals/ Journals' : 'Add Periodicals/ Journals'}</h5>
                        <FontAwesomeIcon icon={['fas', 'times']} className='ml-3' size="lg" color="#000" onClick={() => this.closeAddPeriodical()} style={{ cursor: "pointer" }} />
                    </div>
                    <hr />

                    {/* Select Institute for Add Screen */}
                    {
                        !this.state.isEditPeriodical &&
                        <div className='col-md-12 pl-4 pt-2 pb-3'>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Select Institute<span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={Object.values(this.state.multipleInstituteDetails).map(item => ({
                                            value: item.iid,
                                            label: item.institute_name,
                                        }))}
                                        value={this.state.addPeriodicalInstituteIID}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                addPeriodicalInstituteIID: event || [], // Handle empty selection                                          
                                            }
                                                , () => {
                                                    this.getAddPublisherList();
                                                    this.getAddAccessionSeries();
                                                    this.getAddCategory();
                                                    this.getAddDepartment();
                                                    this.getAddVendor();
                                                }
                                            );
                                        }}
                                        placeholder="Select Institute"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>
                        </div>
                    }

                    {
                        this.state.isEditPeriodical ?
                            // update periodical screen
                            <div className='col-md-12 pl-4 pt-2 pb-3'>
                                <p className='fs-16 pb-3 fw-600' style={{ color: '#0465AC' }}>Periodicals/ Journals Details</p>
                                <div className='d-flex pb-3'>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Periodical Title <span className='text-danger'>*</span></label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                            placeholder="Enter Periodical Title"
                                            value={this.state.periodicalTitle}
                                            onChange={(e) => this.setState({ periodicalTitle: e.target.value, periodicalTitleWarning: '' })}
                                        />
                                        <p className='text-danger fs-12'>{this.state.periodicalTitleWarning}</p>
                                    </div>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Publisher</label>
                                        <Select
                                            isMulti
                                            options={this.state.editPublisherData}
                                            value={this.state.publisherName}
                                            onChange={(e) => {
                                                this.setState({
                                                    publisherName: e || [],
                                                });
                                            }}
                                            isSearchable
                                            onInputChange={(inputValue) => {
                                                this.setState({ searchPublisher: inputValue }, () => {
                                                    this.getEditPublisherList(); // Trigger the API call after updating the search term
                                                }, 200);
                                            }}
                                            placeholder="Select Publisher"
                                            isLoading={this.state.loadingEditPublisher} // Show loading spinner while fetching
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    width: '100%',
                                                    minHeight: 42, // Minimum height for the control area
                                                    height: 'auto', // Allow control to grow dynamically
                                                }),
                                                multiValue: (base) => ({
                                                    ...base,
                                                    backgroundColor: 'none',
                                                    borderRadius: '5px',
                                                    border: '1px solid #c4c5c5',
                                                    fontSize: '12px',
                                                    fontWeight: '400',
                                                    color: '#808080',
                                                    display: 'inline-flex',
                                                    margin: '2px',
                                                    whiteSpace: 'nowrap',
                                                }),
                                                multiValueContainer: (base) => ({
                                                    ...base,
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    overflowX: 'auto', // Horizontal scroll when values overflow
                                                    minHeight: 42, // Ensure consistent height when values are selected
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                }),
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    fontSize: '12px',
                                                    fontWeight: '400',
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    fontSize: '12px',
                                                    fontWeight: '400',
                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                    color: state.isSelected ? '#333' : '#555',
                                                }),
                                            }}
                                            // Specify that the menu should be rendered in the document body
                                            menuPortalTarget={document.body}
                                            noOptionsMessage={() => (this.state.loadingEditPublisher ? "Loading..." : "No options found")}
                                        />
                                        {/* <input
                                    type="text"
                                    className="form-control"
                                    style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                    placeholder="Enter Publisher Name"
                                    value={this.state.publisherName}
                                    onChange={(e) => this.setState({ publisherName: e.target.value })}
                                /> */}
                                    </div>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>ISSN Number</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                            placeholder="Enter ISSN Number"
                                            value={this.state.issnNumber}
                                            onChange={(e) => this.setState({ issnNumber: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className='d-flex pb-3'>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Accession Series</label>
                                        <Select
                                            options={Object.values(this.state.editAccessionSeriesData)}
                                            value={this.state.AccessionSeries}
                                            className="basic-multi-select-filter"
                                            onChange={(event) => {
                                                this.setState({
                                                    AccessionSeries: event || '', // Handle empty selection
                                                    AccessionNumber: '',
                                                },
                                                    () => this.GetMaximumLibraryAccession()
                                                );
                                            }}
                                            placeholder="Select Accession Series"
                                            isClearable
                                            isLoading={this.state.loadingEditAccessionSeries} // Show loading spinner while fetching
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    width: '100%',
                                                    minHeight: 42, // Minimum height for the control area
                                                    height: 'auto', // Allow control to grow dynamically
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                }),
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    fontSize: '12px',
                                                    fontWeight: 400,
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    fontSize: '12px',
                                                    fontWeight: 400,
                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                    color: state.isSelected ? '#333' : '#555',
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    fontSize: '12px',
                                                    fontWeight: '400',
                                                }),
                                            }}
                                            menuPortalTarget={document.body}
                                            noOptionsMessage={() => (this.state.loadingEditAccessionSeries ? "Loading..." : "No options found")}
                                            required
                                        />
                                    </div>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Accession Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="addAccessionNumber"
                                            placeholder="Enter Accession Number"
                                            style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                            value={this.state.AccessionNumber} // Bind value to state
                                            onChange={(e) => {
                                                this.setState({
                                                    AccessionNumber: e.target.value || '',
                                                }, () => {
                                                    this.checkAccessionNumber(this.state.AccessionNumber)
                                                })
                                            }}
                                            maxLength={20}
                                        />
                                        <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(Maximum 20 characters are allowed)</p>
                                    </div>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Periodical Category
                                            <FontAwesomeIcon icon={['fas', 'cog']} className='ml-2' size="lg" color="#000" onClick={() => this.setState({ addCategoryModal: true })} style={{ cursor: "pointer" }} />
                                        </label>

                                        <select className="form-control"
                                            style={{ fontSize: '13px' }}
                                            value={this.state.selectedCategory}
                                            onChange={(e) => this.setState({ selectedCategory: e.target.value })}
                                        >
                                            <option value="">Select Category</option>
                                            {
                                                Object.keys(this.state.editCategoryData).map(category => {
                                                    let categoryName = this.state.editCategoryData[category]

                                                    return (
                                                        <option style={{ fontSize: '13px' }} value={category}>{categoryName.category_name + " | " + categoryName.periodicalCategory_InstituteName}</option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className='d-flex'>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Periodicity</label>

                                        <select className="form-control"
                                            style={{ fontSize: '13px' }}
                                            value={this.state.selectedPeriodicity}
                                            onChange={(e) => this.setState({ selectedPeriodicity: e.target.value })}
                                        >
                                            <option value="">Select Periodicity</option>
                                            <option value="daily">Daily</option>
                                            <option value="weekly">Weekly</option>
                                            <option value="fortnightly">Fortnightly</option>
                                            <option value="monthly">Monthly</option>
                                            <option value="bimonthly">Bi Monthly</option>
                                            <option value="quarterly">Quarterly</option>
                                            <option value="half yearly">Half yearly</option>
                                            <option value="yearly">Yearly</option>
                                            <option value="triennial">Triennial</option>
                                            <option value="tri annually">Tri Annually</option>
                                        </select>
                                    </div>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Department</label>

                                        <ReactSelect
                                            className='upperSelectBoxZIndex'
                                            value={this.state.selectedDepartmentObject}
                                            options={this.state.editDepartmentData}
                                            defaultValue=""
                                            isMulti
                                            isClearable
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            styles={customStyles}
                                            onChange={(e) => {
                                                this.setState({ selectedDepartmentObject: e })
                                                this.selectDepartments(e)
                                            }
                                            }
                                        />
                                    </div>
                                </div>
                                <p className='fs-14 fieldHeadColor mt-2'>{this.state.accessError}</p>
                            </div> :
                            //  add periodical screen
                            <div className='col-md-12 pl-4 pt-2 pb-3'>
                                <p className='fs-16 pb-3 fw-600' style={{ color: '#0465AC' }}>Periodicals/ Journals Details</p>
                                <div className='d-flex pb-3'>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Periodical Title <span className='text-danger'>*</span></label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                            placeholder="Enter Periodical Title"
                                            value={this.state.periodicalTitle}
                                            onChange={(e) => this.setState({ periodicalTitle: e.target.value, periodicalTitleWarning: '' })}
                                        />
                                        <p className='text-danger fs-12'>{this.state.periodicalTitleWarning}</p>
                                    </div>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Publisher</label>
                                        <Select
                                            isMulti
                                            options={this.state.addPublisherData}
                                            value={this.state.publisherName}
                                            onChange={(e) => {
                                                this.setState({
                                                    publisherName: e || [],
                                                });
                                            }}
                                            isSearchable
                                            onInputChange={(inputValue) => {
                                                this.setState({ searchPublisher: inputValue }, () => {
                                                    this.getAddPublisherList(); // Trigger the API call after updating the search term
                                                }, 200);
                                            }}
                                            placeholder="Select Publisher"
                                            isLoading={this.state.loadingAddPublisher} // Show loading spinner while fetching
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    width: '100%',
                                                    minHeight: 42, // Minimum height for the control area
                                                    height: 'auto', // Allow control to grow dynamically
                                                }),
                                                multiValue: (base) => ({
                                                    ...base,
                                                    backgroundColor: 'none',
                                                    borderRadius: '5px',
                                                    border: '1px solid #c4c5c5',
                                                    fontSize: '12px',
                                                    fontWeight: '400',
                                                    color: '#808080',
                                                    display: 'inline-flex',
                                                    margin: '2px',
                                                    whiteSpace: 'nowrap',
                                                }),
                                                multiValueContainer: (base) => ({
                                                    ...base,
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    overflowX: 'auto', // Horizontal scroll when values overflow
                                                    minHeight: 42, // Ensure consistent height when values are selected
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                }),
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    fontSize: '12px',
                                                    fontWeight: '400',
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    fontSize: '12px',
                                                    fontWeight: '400',
                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                    color: state.isSelected ? '#333' : '#555',
                                                }),
                                            }}
                                            // Specify that the menu should be rendered in the document body
                                            menuPortalTarget={document.body}
                                            noOptionsMessage={() => (this.state.loadingAddPublisher ? "Loading..." : "No options found")}
                                        />
                                        {/* <input
                                    type="text"
                                    className="form-control"
                                    style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                    placeholder="Enter Publisher Name"
                                    value={this.state.publisherName}
                                    onChange={(e) => this.setState({ publisherName: e.target.value })}
                                /> */}
                                    </div>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>ISSN Number</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                            placeholder="Enter ISSN Number"
                                            value={this.state.issnNumber}
                                            onChange={(e) => this.setState({ issnNumber: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className='d-flex pb-3'>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Accession Series</label>
                                        <Select
                                            options={Object.values(this.state.addAccessionSeriesData)}
                                            value={this.state.AccessionSeries}
                                            className="basic-multi-select-filter"
                                            onChange={(event) => {
                                                this.setState({
                                                    AccessionSeries: event || '', // Handle empty selection
                                                    AccessionNumber: '',
                                                },
                                                    () => this.GetMaximumLibraryAccession()
                                                );
                                            }}
                                            placeholder="Select Accession Series"
                                            isClearable
                                            isLoading={this.state.loadingAddAccessionSeries} // Show loading spinner while fetching
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    width: '100%',
                                                    minHeight: 42, // Minimum height for the control area
                                                    height: 'auto', // Allow control to grow dynamically
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                }),
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    fontSize: '12px',
                                                    fontWeight: 400,
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    fontSize: '12px',
                                                    fontWeight: 400,
                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                    color: state.isSelected ? '#333' : '#555',
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    fontSize: '12px',
                                                    fontWeight: '400',
                                                }),
                                            }}
                                            menuPortalTarget={document.body}
                                            noOptionsMessage={() => (this.state.loadingAddAccessionSeries ? "Loading..." : "No options found")}
                                            required
                                        />
                                    </div>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Accession Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="addAccessionNumber"
                                            placeholder="Enter Accession Number"
                                            style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                            value={this.state.AccessionNumber} // Bind value to state
                                            onChange={(e) => {
                                                this.setState({
                                                    AccessionNumber: e.target.value || '',
                                                }, () => {
                                                    this.checkAccessionNumber(this.state.AccessionNumber)
                                                })
                                            }}
                                            maxLength={20}
                                        />
                                        <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(Maximum 20 characters are allowed)</p>
                                    </div>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Periodical Category
                                            <FontAwesomeIcon icon={['fas', 'cog']} className='ml-2' size="lg" color="#000" onClick={() => this.setState({ addCategoryModal: true })} style={{ cursor: "pointer" }} />
                                        </label>

                                        <select className="form-control"
                                            style={{ fontSize: '13px' }}
                                            value={this.state.selectedCategory}
                                            onChange={(e) => this.setState({ selectedCategory: e.target.value })}
                                        >
                                            <option value="">Select Category</option>
                                            {
                                                Object.keys(this.state.addCategoryData).map(category => {
                                                    let categoryName = this.state.addCategoryData[category]

                                                    return (
                                                        <option style={{ fontSize: '13px' }} value={category}>{categoryName.category_name + " | " + categoryName.periodicalCategory_InstituteName}</option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className='d-flex'>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Periodicity</label>

                                        <select className="form-control"
                                            style={{ fontSize: '13px' }}
                                            value={this.state.selectedPeriodicity}
                                            onChange={(e) => this.setState({ selectedPeriodicity: e.target.value })}
                                        >
                                            <option value="">Select Periodicity</option>
                                            <option value="daily">Daily</option>
                                            <option value="weekly">Weekly</option>
                                            <option value="fortnightly">Fortnightly</option>
                                            <option value="monthly">Monthly</option>
                                            <option value="bimonthly">Bi Monthly</option>
                                            <option value="quarterly">Quarterly</option>
                                            <option value="half yearly">Half yearly</option>
                                            <option value="yearly">Yearly</option>
                                            <option value="triennial">Triennial</option>
                                            <option value="tri annually">Tri Annually</option>
                                        </select>
                                    </div>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Department</label>

                                        <ReactSelect
                                            className='upperSelectBoxZIndex'
                                            value={this.state.selectedDepartmentObject}
                                            options={this.state.addDepartmentData}
                                            defaultValue=""
                                            isMulti
                                            isClearable
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            styles={customStyles}
                                            onChange={(e) => {
                                                this.setState({ selectedDepartmentObject: e })
                                                this.selectDepartments(e)
                                            }
                                            }
                                        />
                                    </div>
                                </div>
                                <p className='fs-14 fieldHeadColor mt-2'>{this.state.accessError}</p>
                            </div>
                    }

                    {
                        !this.state.isEditPeriodical &&
                        <div className='col-md-12 pl-4 pt-2'>
                            <p className='fs-16 pb-1 fw-600' style={{ color: '#0465AC' }}>Subscriptions</p>
                            <div className='scroll-subscriptionContainer col-md-12 pl-0 pr-0 pt-2 pb-2'>
                                {
                                    this.state.subscriptions.length > 0 &&
                                    this.state.subscriptions.map((subscription, index) => (
                                        <div key={index + 1}>
                                            <p className='fs-16 pb-2 pt-3 fw-600' style={{ color: '#313131' }}>Subscription {index + 1}
                                                <span className='pr-4' style={{ float: 'right' }}>
                                                    <FontAwesomeIcon icon={['fas', 'trash-alt']} className='ml-3 fieldHeadColor' onClick={() => this.deleteSubscription(index + 1)} size="sm" style={{ cursor: "pointer" }} />
                                                </span>
                                            </p>
                                            <div className='d-flex pb-3'>
                                                <div className='col-md-4 pl-0'>
                                                    <label className='fs-14 fieldHeadColor '>Vendor</label>

                                                    <select className="form-control"
                                                        style={{ fontSize: '13px' }}
                                                        value={subscription.vendor}
                                                        onChange={(e) => this.handleInputChange(index + 1, 'vendor', e.target.value)}
                                                    >
                                                        <option value="">Select Vendor</option>
                                                        {
                                                            Object.keys(this.state.addVendorData).map(vendor => {
                                                                let vendorName = this.state.addVendorData[vendor]

                                                                return (
                                                                    <option style={{ fontSize: '13px' }} value={vendor}>{vendorName.displayname}</option>
                                                                );
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className='col-md-4 pl-0'>
                                                    <label className='fs-14 fieldHeadColor '>Subscription Start Date</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                        placeholder="Select Subscription Start Date"
                                                        value={subscription.startDate}
                                                        onChange={(e) => this.handleInputChange(index + 1, 'startDate', e.target.value)}
                                                    />
                                                    <p className='text-danger fs-12'>{subscription.startDateWarning}</p>
                                                </div>
                                                <div className='col-md-4 pl-0'>
                                                    <label className='fs-14 fieldHeadColor '>Subscription End Date</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                        placeholder="Select Subscription End Date"
                                                        value={subscription.endDate}
                                                        onChange={(e) => this.handleInputChange(index + 1, 'endDate', e.target.value)}
                                                    />
                                                    <p className='text-danger fs-12'>{subscription.endDateWarning}</p>
                                                </div>
                                            </div>
                                            <div className='d-flex'>
                                                <div className='col-md-4 pl-0'>
                                                    <label className='fs-13 fieldHeadColor '>Number of Expected Issues</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                        placeholder="Enter Number of Expected Issues"
                                                        value={subscription.expectedIssues}
                                                        onChange={(e) => {
                                                            // Check if the input is a positive number
                                                            if (/^\d+$/.test(e.target.value) || e.target.value === '') {
                                                                this.handleInputChange(index + 1, 'expectedIssues', e.target.value)
                                                            }
                                                        }}

                                                    // onChange={(e) => this.handleInputChange(index + 1, 'expectedIssues', e.target.value)}
                                                    />
                                                </div>
                                                <div className='col-md-4 pl-0'>
                                                    <label className='fs-13 fieldHeadColor '>Average Price Per Copy</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                        placeholder="Enter Average Price Per Issue"
                                                        value={subscription.avgPricePerCopy}
                                                        onChange={(e) => {
                                                            // Check if the input is a positive number
                                                            if (/^\d*\.?\d{0,3}$/.test(e.target.value) || e.target.value === '') {
                                                                this.handleInputChange(index + 1, 'avgPricePerCopy', e.target.value)
                                                            }
                                                        }}
                                                    // onChange={(e) => this.handleInputChange(index + 1, 'avgPricePerCopy', e.target.value)}
                                                    />
                                                    <p className='text-danger fs-12' >{subscription.mandatoryWarning}</p>
                                                </div>
                                                <div className='col-md-4 pl-0'>
                                                    <label className='fs-13 fieldHeadColor '>Total Price Per Subscription</label>
                                                    <div className='d-flex justify-content-between'>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', maxWidth: '77%' }}
                                                            value={
                                                                (subscription.expectedIssues === '' || subscription.expectedIssues == 0)
                                                                    ? 0
                                                                    : subscription.expectedIssues * subscription.avgPricePerCopy
                                                            }
                                                            disabled
                                                        />
                                                        <input
                                                            type="text"
                                                            className="form-control ml-2 col"
                                                            style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                            disabled
                                                            value="₹"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                            <p className='fs-14 py-3 fw-600'><span
                                style={{
                                    color: this.isAddButtonDisabled() ? '#A0A0A0' : '#004D86',
                                    textDecoration: 'underline',
                                    cursor: this.isAddButtonDisabled() ? 'default' : 'pointer'
                                }}
                                onClick={!this.isAddButtonDisabled() ? this.addSubscription : null}

                            >+ Add Subscription</span></p>
                            <hr />
                            <div className='d-flex col-md-12 pl-0'>
                                <span className='col-md-8 pl-0'>Total Price (in Rs.)</span>
                                <span className='ml-2'>
                                    <div className='d-flex justify-content-between'>
                                        <input
                                            type="text"
                                            className="form-control"
                                            style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', maxWidth: '77%' }}
                                            disabled
                                            value={parseFloat(this.state.totalPrice).toFixed(3)}
                                        />
                                        <input
                                            type="text"
                                            className="form-control ml-2 col"
                                            style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                            disabled
                                            value="₹"
                                        />
                                    </div>
                                </span>
                            </div>
                        </div>}
                    <div className="modal-footer pt-5">
                        <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeAddPeriodical()}>Cancel</button>
                        <button className="btn btn-primary"
                            onClick={() => this.validatePeriodicals()}
                        >{this.state.isEditPeriodical ? 'Update Periodicals/ Journals' : 'Add Periodicals/ Journals'}</button>
                    </div>
                </div>
            </div>
        );
    }

    // Method to validate periodicals
    validatePeriodicals = () => {

        let isValid = true;

        if (this.state.periodicalTitle.trim() == '') {
            this.setState({
                periodicalTitleWarning: 'Periodical Title cannot be empty.'
            })
            isValid = false;
        } else {
            this.setState({
                periodicalTitleWarning: ''
            });

            isValid = true;
        }

        const { subscriptions } = this.state;

        const updatedSubscriptions = subscriptions.map((subscription) => {
            let startDateWarning = '';
            let endDateWarning = '';
            let mandatoryWarning = '';

            // Check if any of the specified fields are not empty
            const fields = [
                subscription.vendor,
                subscription.startDate,
                subscription.startDateWarning,
                subscription.endDate,
                subscription.endDateWarning,
                subscription.expectedIssues,
                subscription.avgPricePerCopy,
                subscription.subUniqueid,
                subscription.addOrUpdateKey,
                subscription.mandatoryWarning
            ];
            // const isAnyFieldNotEmpty = fields.some(field => field !== '');
            const isAnyFieldNotEmpty = fields.some(
                field => field !== undefined && field !== null && field !== ''
            );

            if (isAnyFieldNotEmpty) {
                isValid = true;
                if ((subscription.startDate !== '0000-00-00' && subscription.startDate !== '') && (subscription.endDate === '0000-00-00' || subscription.endDate === '')) {
                    endDateWarning = 'End date cannot be empty.';
                    isValid = false;
                } else if ((subscription.startDate === '0000-00-00' || subscription.startDate === '') && (subscription.endDate !== '0000-00-00' && subscription.endDate !== '')) {
                    startDateWarning = 'Start date cannot be empty.';
                    isValid = false;
                } else if ((subscription.startDate !== '0000-00-00' && subscription.startDate !== '') && (subscription.endDate !== '0000-00-00' && subscription.endDate !== '')) {
                    if (subscription.startDate > subscription.endDate) {
                        endDateWarning = 'End date cannot be before start date.';
                        isValid = false;
                    }
                }

                // Check mandatory fields
                if (subscription.startDate === '0000-00-00' || subscription.startDate === '' ||
                    subscription.endDate === '0000-00-00' || subscription.endDate === '' ||
                    String(subscription.avgPricePerCopy) === '0' || String(subscription.avgPricePerCopy) === '') {

                    if (subscription.startDate === '0000-00-00' || subscription.startDate === '') {
                        startDateWarning = 'Start Date cannot be empty.';
                    }
                    if (subscription.endDate === '0000-00-00' || subscription.endDate === '') {
                        endDateWarning = 'End Date cannot be empty.';
                    }
                    if (String(subscription.avgPricePerCopy) === '0' || String(subscription.avgPricePerCopy) === '') {
                        mandatoryWarning = 'Average Price Per Copy cannot be empty.';
                    }
                    isValid = false;
                }
            }

            return {
                ...subscription,
                startDateWarning,
                mandatoryWarning,
                endDateWarning
            };
        });

        if (this.state.periodicalTitle != '') {
            const areAllSubscriptionsEmpty = updatedSubscriptions.every(subscription => {
                return !Object.values(subscription).some(value => value !== '' && value !== 1); // Check all fields except id
            });

            if (areAllSubscriptionsEmpty) {
                this.setState({ subscriptions: [] });
            } else {
                this.setState({ subscriptions: updatedSubscriptions });
            }
        }

        if (isValid) {

            if (this.state.isEditPeriodical) {

                this.apiCallToUpdatePeriodical()
            } else {

                if (this.state.periodicalTitle != '') {
                    const areAllSubscriptionsEmpty = updatedSubscriptions.every(subscription => {
                        return !Object.values(subscription).some(value => value !== '' && value !== 1); // Check all fields except id
                    });

                    if (areAllSubscriptionsEmpty) {
                        this.setState({ subscriptions: [] }, () => this.apiCallToAddPeriodicals());
                    } else {
                        this.setState({ subscriptions: updatedSubscriptions }, () => this.apiCallToAddPeriodicals());
                    }
                }
            }
        }
    }

    // Method to open add modal
    addOrEditPeriodicalModal = () => {

        const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['periodicals'].find(access => access === 'add');

        if (addGrantAccess !== undefined) {

            this.setState({
                addPeriodical: true,
                isEditPeriodical: false,
                editPeriodicalUID: ''
            })

        } else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // Method to close add or edit modal
    closeAddPeriodical = () => {
        this.setState({
            addPeriodical: false,
            subscriptions: [
                {
                    id: 1,
                    vendor: '',
                    startDate: '',
                    startDateWarning: '',
                    endDate: '',
                    endDateWarning: '',
                    expectedIssues: '',
                    avgPricePerCopy: '',
                    subUniqueid: '',
                    addOrUpdateKey: ''
                }
            ],
            totalPrice: '0',
            selectedCategory: '',
            selectedDepartmentObject: '',
            selectedDepartment: '',
            periodicalTitle: '',
            periodicalTitleWarning: '',
            publisherName: '',
            issnNumber: '',
            selectedPeriodicity: '',
            AccessionSeries: '',
            AccessionNumber: '',
            currentEditPublisherIds: [],
        })
    }

    // Method to add new subcriptions
    handleInputChange = (id, field, value) => {
        this.setState((prevState) => {
            const subscriptions = prevState.subscriptions.map((subscription, index) => {
                if (index + 1 === id) {
                    return { ...subscription, [field]: value };
                }
                return subscription;
            });
            return { subscriptions };
        }, () => this.calculateTotalPrice());
    }

    // Method to add new subcriptions
    addSubscription = () => {
        this.setState((prevState) => {
            const newSubscription = {
                id: prevState.subscriptions.length + 1,
                vendor: '',
                startDate: '',
                endDate: '',
                expectedIssues: '',
                endDateWarning: '',
                startDateWarning: '',
                avgPricePerCopy: '',
                subUniqueid: '',
                addOrUpdateKey: ''
            };
            return { subscriptions: [...prevState.subscriptions, newSubscription] };
        }, () => this.calculateTotalPrice);
    }

    // Method to delete subcriptions
    deleteSubscription = (id) => {
        this.setState((prevState) => {
            let subscriptions;

            if (prevState.subscriptions.length === 1) {
                // const subscriptions = prevState.subscriptions.map((subscription, index) => {
                //     if (index + 1 === id) {
                //         return {
                //             id: index + 1,
                //             vendor: '',
                //             startDate: '',
                //             endDate: '',
                //             expectedIssues: '',
                //             endDateWarning: '',
                //             startDateWarning: '',
                //             avgPricePerCopy: '',
                //             subUniqueid: '',
                //             addOrUpdateKey: ''
                //         };
                //     }
                //     return subscription;
                // });
                subscriptions = [];
                return { subscriptions };
            } else {
                const subscriptions = prevState.subscriptions.filter((subscription, index) => index + 1 !== id);
                return { subscriptions };
            }
        }, this.calculateTotalPrice);
    }

    // Method to handle add new subcriptions
    isAddButtonDisabled = () => {
        if (this.state.subscriptions.length > 0) {

            const lastSubscription = this.state.subscriptions[this.state.subscriptions.length - 1];
            const { startDate, endDate, avgPricePerCopy } = lastSubscription;
            return !startDate || !endDate || !avgPricePerCopy;

        }
    }

    // Method to close category Modal
    closeCategoryModal = () => {
        this.setState({
            addCategoryModal: false,
            resourceCategoryIID: [{
                value: config.institute_id,
                label: this.props?.multipleInstituteDetails?.multipleInstituteDetails?.[config.institute_id]?.institute_name || ''
            }],
        })
    }

    // Method called to clear filter
    clearFilter = () => {
        this.setState({
            offset: 0,
            pageIndex: 1,
            categoryFilter: '',
            periodicalTitleFilter: '',
            periodicityFilter: '',
            iidFilter: config.institute_id,
            selectedPeriodicalds: [],
            periodicalDeleteStatus: 'active',
            periodicalTitleFilterTemp: "",
            categoryFilterTemp: "",
            periodicityFilterTemp: "",
            statusFilterTemp: "active",
            iidFilterTemp: config.institute_id,

        }, () => this.getPeriodicalList())
    }

    // METHOD TO SELECT LIMIT
    selectLimit = (e) => {
        this.setState({
            limit: e.target.value,
            pageIndex: 1,
            offset: 0,
            categoryFilter: this.state.categoryFilter,
            periodicalTitleFilter: this.state.periodicalTitleFilter,
            iidFilter: this.state.iidFilter, // config.institute_id,
            periodicityFilter: this.state.periodicityFilter,
            periodicalDeleteStatus: this.state.periodicalDeleteStatus,
        }, () => {
            // METHOD CALLED TO GET MEMBER DETAILS
            this.getPeriodicalList();
        });
    }

    // METHOD TO UPDATE PAGINATION PAGE NUMBER
    updatePaginationCount = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber,
            offset: (pageNumber - 1) * this.state.limit,
            selectedPeriodicalds: [],
            categoryFilter: this.state.categoryFilter,
            periodicalTitleFilter: this.state.periodicalTitleFilter,
            iidFilter: this.state.iidFilter, // config.institute_id,
            periodicityFilter: this.state.periodicityFilter,
            periodicalDeleteStatus: this.state.periodicalDeleteStatus,
        }, () => {
            // METHOD CALLED TO GET MEMBER DETAILS
            this.getPeriodicalList();
        });
    }

    // Method called to validate subcriptions
    validateUpdateSubcriptions = () => {
        this.setState((prevState) => {
            const subscriptions = prevState.subscriptions.map((subscription, index) => {
                let startDateWarning = '';
                let endDateWarning = '';

                if (subscription.startDate !== '' && subscription.endDate === '') {
                    endDateWarning = 'End date cannot be empty.';
                } else if (subscription.startDate === '' && subscription.endDate !== '') {
                    startDateWarning = 'Start date cannot be empty.';
                } else if (subscription.startDate !== '' && subscription.endDate !== '') {
                    if (subscription.startDate > subscription.endDate) {
                        endDateWarning = 'End date cannot be before start date.';
                    }
                }

                return {
                    ...subscription,
                    startDateWarning,
                    endDateWarning
                };
            });

            return { subscriptions };
        });
    }

    // Method to open edit subscription modal
    openSubscriptionModal = (periodicalUID, subscriptions, title, periodicalIID) => {

        // Map the subscriptions to the required format
        const updatedSubscriptions = subscriptions.map((sub, index) => ({
            id: index + 1,
            vendor: sub.vendorId,
            startDate: sub.startDate,
            startDateWarning: '',
            endDate: sub.endDate,
            endDateWarning: '',
            expectedIssues: sub.numberOfIssues,
            avgPricePerCopy: sub.pricePerCopy,
            subUniqueid: sub.subUniqueid,
            addOrUpdateKey: sub.addOrUpdateKey
        }));

        this.setState({
            updateSubcriptionModal: true,
            priodicalTitleForModal: title,
            periodicalUniqueIdofSub: periodicalUID,
            subscriptions: updatedSubscriptions,
            editPeriodicalIID: periodicalIID
        }, () => {
            this.calculateTotalPrice();          // existing function call
            this.getAddSubVendorData();          // <-- your API call added here
        });
    }

    // METHOD TO DELETE SUBSCRIPTION
    apiCallToDeleteSubscription = async (subUniqueid, periodicalUniqueIdofSub) => {

        let requestData = {
            "iid": this.state.editPeriodicalIID, //config.institute_id,
            "unique_idArray": [subUniqueid],
            "periodicalUid": periodicalUniqueIdofSub,
            "facultyId": config.faculty_id
        };
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_DeleteSubscriptionDetails',
            requestData,
            '/api/library/libraryPeriodicals.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToDeleteSubscription()
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == "success") {

                    // this.setState({
                    //     successModal: true,
                    //     successModalType: 'success',
                    //     successMessage: apiResult.message,
                    // });
                    this.calculateTotalPrice()
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while deleting subscription. Please try again later.'
                });
            }
        }
    }

    // Method To Delete Subscription from modal
    functionToDeleteSubscription = (subUniqueid, id) => {

        const deleteGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['periodicals'].find(access => access === 'delete');

        if (deleteGrantAccess !== undefined) {

            const { periodicalUniqueIdofSub } = this.state;

            this.setState((prevState) => {
                let subscriptions;
                if (prevState.subscriptions.length === 1) {
                    subscriptions = [];
                    return { subscriptions };
                } else {
                    const subscriptions = prevState.subscriptions.filter((subscription, index) => index + 1 !== id);
                    return { subscriptions };
                }
            }, this.calculateTotalPrice);

            this.apiCallToDeleteSubscription(subUniqueid, periodicalUniqueIdofSub);

        } else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // API CALL METHOD TO SUBSCRIPTION
    apiCallToUpdateSubscriptions = async () => {
        let requestData = {
            "iid": this.state.editPeriodicalIID, // config.institute_id,
            "facultyId": config.faculty_id,
            "periodicalId": this.state.periodicalUniqueIdofSub,
            "subscriptionArray": this.state.subscriptions
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_UpdateSubscriptionDetails',
            requestData,
            '/api/library/libraryPeriodicals.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToUpdateSubscriptions()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == 'success') {
                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                    });

                    this.closeUpdateSubcriptionModal();
                    this.getPeriodicalList();
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while updating periodical. Please try again later.',
                });
            }
        }
    }

    validateSubscriptions = () => {

        const editGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['periodicals'].find(access => access === 'edit');

        if (editGrantAccess !== undefined) {

            let isValid = false;
            const { subscriptions } = this.state;

            const updatedSubscriptions = subscriptions.map((subscription) => {
                let startDateWarning = '';
                let endDateWarning = '';
                let mandatoryWarning = '';

                isValid = true;
                if ((subscription.startDate !== '0000-00-00' && subscription.startDate !== '') && (subscription.endDate === '0000-00-00' || subscription.endDate === '')) {
                    endDateWarning = 'End date cannot be empty.';
                    isValid = false;
                } else if ((subscription.startDate === '0000-00-00' || subscription.startDate === '') && (subscription.endDate !== '0000-00-00' && subscription.endDate !== '')) {
                    startDateWarning = 'Start date cannot be empty.';
                    isValid = false;
                } else if ((subscription.startDate !== '0000-00-00' && subscription.startDate !== '') && (subscription.endDate !== '0000-00-00' && subscription.endDate !== '')) {
                    if (subscription.startDate > subscription.endDate) {
                        endDateWarning = 'End date cannot be before start date.';
                        isValid = false;
                    }
                }

                // Check mandatory fields
                if (subscription.startDate === '0000-00-00' || subscription.startDate === '' ||
                    subscription.endDate === '0000-00-00' || subscription.endDate === '' ||
                    String(subscription.avgPricePerCopy) === '0' || String(subscription.avgPricePerCopy) === '') {
                    mandatoryWarning = 'Please fill mandatory fields.';
                    isValid = false;
                }

                return {
                    ...subscription,
                    startDateWarning,
                    mandatoryWarning,
                    endDateWarning
                };
            });

            this.setState({ subscriptions: updatedSubscriptions });


            if (isValid == true) {

                this.setState((prevState) => {
                    const subscriptions = prevState.subscriptions.map((subscription, index) => {
                        let startDateWarning = '';
                        let endDateWarning = '';

                        return {
                            ...subscription,
                            startDateWarning,
                            endDateWarning
                        };
                    });

                    this.setState({ subscriptions });
                });

                this.apiCallToUpdateSubscriptions()
            }
        } else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO EXPORT PERIODICALS DETAILS
    exportExpenseDetails = () => {
        this.setState({
            exportDetails: true
        }, () => {
            document.getElementById('expenseExport').click();
            this.setState({ dataHideWhileExporting: true })
            this.setState({
                exportDetails: false
            });
        });
    }

    // METHOD TO CLOSE DELETE RECEIPT
    closeDeletePeriodical = () => {
        this.setState({
            deletePeriodical: false,
            periodicalUIDToDeletePeriodical: '',
            selectedPeriodicalds: [],
        });
    }

    // METHOD TO CHECK ACCESS FOR DELETE OPERATION
    checkDeleteAccess = (status) => {
        const hasDifferentIID = new Set(selectedCheckboxIID).size > 1;

        if (hasDifferentIID) {
            this.setState({ selectedPeriodicalds: [] })
            toast.warn("Please select periodicals from the same Institute to perform this action.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            const deleteGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['periodicals'].find(access => access === 'delete');

            if (deleteGrantAccess !== undefined) {

                this.apiCallToDeletePeriodical(status);
                // this.setState({
                //     deletePeriodical: true,
                //     periodicalUIDToDeletePeriodical: periodicalUID
                // });
            }
            else {
                this.setState({
                    successModal: true,
                    successModalType: 'warning',
                    successMessage: 'This operation is restricted by the Library admin.'
                });
            }
        }
    }

    // METHOD TO GET UPDATE PERIODICAL DETAILS
    getPeriodicalUpdateDetails = (periodical) => {

        const editGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['periodicals'].find(access => access === 'edit');

        if (editGrantAccess !== undefined) {

            let streamIds = periodical.DepartmentIDArray;
            let Department = periodical.sidWiseName;
            let selectedDepartmentObject = [];
            Object.keys(Department).map((sid) => {
                let stream_name = Department[sid];
                let options = { "value": sid, "label": stream_name };
                selectedDepartmentObject.push(options);
            })

            let selectedDepartment = periodical.DepartmentIDArray;
            let currentEditPublisherIds = Array.isArray(periodical.publisherIdArray) ? periodical.publisherIdArray : [];
            let normalizedPublisherIds = currentEditPublisherIds.map(String);
            let selectedPublisher = this.state.editPublisherData.filter(publisher =>
                normalizedPublisherIds.includes(String(publisher.value))
            );

            let selectedAccessionSeries = this.state.editAccessionSeriesData.filter(
                item => item.value == periodical.accessionSeriesId
            );
            let accessionNumberValue = periodical.accessionNumber;



            // Map the subscriptions to the required format
            const updatedSubscriptions = periodical.subscriptions.map((sub, index) => ({
                id: index + 1,
                vendor: sub.vendorId,
                startDate: sub.startDate,
                startDateWarning: '',
                endDate: sub.endDate,
                endDateWarning: '',
                expectedIssues: sub.numberOfIssues,
                avgPricePerCopy: sub.pricePerCopy,
                subUniqueid: sub.subUniqueid,
                addOrUpdateKey: sub.addOrUpdateKey
            }));

            this.setState({
                periodicalTitle: periodical.title,
                publisherName: selectedPublisher,// periodical.publisher,
                currentEditPublisherIds,
                issnNumber: periodical.ISSN,
                selectedCategory: periodical.periodical_category_id,
                selectedPeriodicity: periodical.periodicity,
                selectedDepartment: selectedDepartment,
                selectedDepartmentObject,
                editPeriodicalUID: periodical.periodicalUID,
                subscriptions: updatedSubscriptions,
                AccessionSeries: selectedAccessionSeries,
                AccessionNumber: accessionNumberValue
            }, () => this.calculateTotalPrice());

            this.setState({
                isEditPeriodical: true,
                addPeriodical: true
            });

        } else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // API CALL METHOD TO PERIODICAL
    apiCallToUpdatePeriodical = async () => {
        let publisherIdArray = [];
        if (this.state.publisherName) {
            this.state.publisherName?.map((item) => {
                publisherIdArray.push(item.value)
            })
        } else {
            publisherIdArray = []
        }

        let requestData = {
            "uniqueId": this.state.editPeriodicalUID,
            "iid": this.state.editPeriodicalIID, //config.institute_id,
            "facultyId": config.faculty_id,
            "title": this.state.periodicalTitle.trim(),
            "publisherName": publisherIdArray, // this.state.publisherName,
            "periodical_category_id": this.state.selectedCategory,
            "periodicity": this.state.selectedPeriodicity,
            "ISSN": this.state.issnNumber,
            "streams": this.state.selectedDepartment == '' ? [] : this.state.selectedDepartment,
            "subscriptionArray": this.state.subscriptions,
            "accessionSeriesId": this.state.AccessionSeries.length > 0 ? this.state.AccessionSeries[0].value : this.state.AccessionSeries.value,
            "accessionNumber": this.state.AccessionNumber,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_updatePeriodicalsDetails',
            requestData,
            '/api/library/libraryPeriodicals.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToUpdatePeriodical()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == 'success') {
                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                    });

                    this.closeAddPeriodical();
                    this.getPeriodicalList();
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while updating periodical. Please try again later.',
                });
            }
        }
    }

    // EXPORT TABLE TO CSV
    tableToCSV = () => {
        // Creating csv string with headers
        let csvString = `\n"Title*","Publisher","ISSN Number","Periodical Category","Periodicity","Department"\n`;

        // Adding sample hard-coded data
        const sampleData = [
            ["Sample Periodical 1", "Publisher", "1234-4567", "Science", "Yearly", "Computer Engineering, Electrical Engineering"],
        ];

        // Adding each row of sample data to csvString
        sampleData.forEach(row => {
            csvString += `"${row.join('","')}"\n`;
        });

        if (csvString !== '') {
            var downloadLink = document.createElement('a');
            downloadLink.download = "sample-periodical-details.csv";
            downloadLink.href = 'data:application/csv;charset=UTF-8,%EF%BB%BF' + encodeURIComponent(csvString);
            downloadLink.target = '_blank';
            document.getElementById('exportList').appendChild(downloadLink);
            downloadLink.click();
        }
    }

    // EXPORT SUBSCRIPTION TABLE TO CSV
    subscriptionTableToCSV = () => {
        // Creating csv string with headers
        let csvString = `\n"Periodical Title*","Vendor","Subscription Start Date*","Subscription End Date*","Number Of Expected Issues","Average Price Per Copy*"\n`;

        // Adding sample hard-coded data
        const sampleData = [
            ["Sample Periodical 1", "VM Pvt Ltd", "2025-01-01", "2025-12-31", "5", "50"],
        ];

        // Adding each row of sample data to csvString
        sampleData.forEach(row => {
            csvString += `"${row.join('","')}"\n`;
        });

        if (csvString !== '') {
            var downloadLink = document.createElement('a');
            downloadLink.download = "sample-subscription-details.csv";
            downloadLink.href = 'data:application/csv;charset=UTF-8,%EF%BB%BF' + encodeURIComponent(csvString);
            downloadLink.target = '_blank';
            document.getElementById('exportList').appendChild(downloadLink);
            downloadLink.click();
        }
    }

    // METHOD TO SELECT SINGLE EMPLOYEE
    selectSinglePeriodical = (memberId) => {

        let selectedPeriodicalds = this.state.selectedPeriodicalds;

        if (selectedPeriodicalds.includes(memberId)) {
            selectedPeriodicalds = selectedPeriodicalds.filter(id => id != memberId);
        } else {
            selectedPeriodicalds.push(memberId);
        }

        if (selectedPeriodicalds.length > 0) {
            this.setState({
                showValidDates: true,
            });
        } else {
            this.setState({
                showValidDates: false,
                validFromDate: '',
                validToDate: '',
                isDateEmpty: false
            });
        }

        this.setState({
            selectedPeriodicalds,
        });

    }

    // METHOD TO SELECT ALL PERIODICALS
    selectAllPeriodicals = (e) => {
        let memberSet = new Set();

        if (e.target.checked) {
            if (Object.keys(this.state.periodicalAllData).length > 0) {
                Object.keys(this.state.periodicalAllData).map(employeeId => {
                    memberSet.add(employeeId);
                });
            }
            this.setState({
                showValidDates: true,
            });
        } else {
            this.setState({
                showValidDates: false,
                validFromDate: '',
                validToDate: '',
                isDateEmpty: false
            });
        }

        this.setState({
            selectedPeriodicalds: Array.from(memberSet),
        });
    }

    // close import modal for periodicals
    closeImportModalForPeriodicals = () => {
        this.setState({
            isShowImportPeriodicalButton: false
        })
    }

    // close import modal for subscription
    closeImportModalForSubscription = () => {
        this.setState({
            isShowImportSubscriptionButton: false
        })
    }

    openActivitySlider = (id) => {
        this.setState({
            selectedIid: id,
            showActivitySlider: true
        });
    };

    closeActivitySlider = () => {
        this.setState({
            selectedIid: "",
            showActivitySlider: false
        });
    };

    render() {
        // get selected row iid
        selectedCheckboxIID = this.state.selectedPeriodicalds.map(id => {
            const item = this.state.periodicalAllData[id];
            return item ? item.periodicalIID : null;
        }).filter(id => id !== null)
        return (
            <>
                <div>
                    <div className='d-flex col-md-12 pl-0'>
                        <div className="px-0">
                            <div className="row mx-0">
                                {/* Institute */}
                                <div className="col-md-2 pl-0 pr-1">
                                    <label className="fs-13 headColor">Institute</label>
                                    <select
                                        className="form-control"
                                        style={{ fontSize: "13px" }}
                                        value={this.state.iidFilterTemp}
                                        onChange={(e) => {
                                            const selectedIID = e.target.value;
                                            if (selectedIID) {
                                                const numericIID = [selectedIID].map(Number);
                                                this.setState(
                                                    { iidFilterTemp: selectedIID, periodicalSearchIID: numericIID, statusFilterTemp: 'active' },
                                                    () => {
                                                        this.filterGetPeriodicalCategoryList();
                                                    }
                                                );
                                            } else {
                                                this.setState(
                                                    {
                                                        iidFilterTemp: "",
                                                        periodicalSearchIID: this.props.iidArray.iidArray,
                                                        statusFilterTemp: 'active'
                                                    },
                                                    () => {
                                                        this.filterGetPeriodicalCategoryList();
                                                    }
                                                );
                                            }
                                        }}
                                    >
                                        <option value="">Select Institute</option>
                                        {Object.values(this.state.multipleInstituteDetails).map((member) => (
                                            <option key={member?.iid} value={member?.iid}>
                                                {member?.institute_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Periodical Title */}
                                <div className="col-md-2 pl-0 pr-1">
                                    <label className="fs-13 headColor">Periodical</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{
                                            fontSize: "13px",
                                            paddingLeft: "10px",
                                            paddingTop: "5px",
                                            paddingBottom: "6px",
                                        }}
                                        placeholder="Search by Title"
                                        value={this.state.periodicalTitleFilterTemp}
                                        onChange={(e) =>
                                            this.setState({ periodicalTitleFilterTemp: e.target.value })
                                        }
                                    />
                                </div>

                                {/* Category */}
                                <div className="col-md-2 pl-0 pr-1">
                                    <label className="fs-13 headColor">Periodical Category</label>
                                    <select
                                        className="form-control"
                                        style={{ fontSize: "13px" }}
                                        value={this.state.categoryFilterTemp}
                                        onChange={(e) =>
                                            this.setState({ categoryFilterTemp: e.target.value })
                                        }
                                    >
                                        <option value="">Select Category</option>
                                        {Object.keys(this.state.filterPeriodicalCategoryData).map((category) => {
                                            let categoryName =
                                                this.state.filterPeriodicalCategoryData[category];
                                            return (
                                                <option
                                                    style={{ fontSize: "13px" }}
                                                    value={category}
                                                    key={category}
                                                >
                                                    {categoryName.category_name +
                                                        " | " +
                                                        categoryName.periodicalCategory_InstituteName}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>

                                {/* Periodicity */}
                                <div className="col-md-2 pl-0 pr-1">
                                    <label className="fs-13 headColor">Periodicity</label>
                                    <select
                                        className="form-control"
                                        style={{ fontSize: "13px" }}
                                        value={this.state.periodicityFilterTemp}
                                        onChange={(e) =>
                                            this.setState({ periodicityFilterTemp: e.target.value })
                                        }
                                    >
                                        <option value="">Select Periodicity</option>
                                        <option value="daily">Daily</option>
                                        <option value="weekly">Weekly</option>
                                        <option value="fortnightly">Fortnightly</option>
                                        <option value="monthly">Monthly</option>
                                        <option value="bimonthly">Bi Monthly</option>
                                        <option value="quarterly">Quarterly</option>
                                        <option value="half yearly">Half yearly</option>
                                        <option value="yearly">Yearly</option>
                                        <option value="triennial">Triennial</option>
                                        <option value="tri annually">Tri Annually</option>
                                    </select>
                                </div>

                                {/* Status */}
                                <div className="col-md-2 pl-0 pr-1">
                                    <label className="fs-13 headColor">Status</label>
                                    <select
                                        className="form-control"
                                        style={{ fontSize: "13px" }}
                                        value={this.state.statusFilterTemp}
                                        onChange={(e) =>
                                            this.setState({ statusFilterTemp: e.target.value })
                                        }
                                    >
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </div>

                                {/* Apply / Clear Buttons */}
                                <div className="col-md-2 pl-0 pr-1 mt-4">
                                    <button
                                        type="button"
                                        style={{ fontSize: "12px", padding: "10px 16px" }}
                                        className="btn btn-primary br-5 mr-2 btn-lg"
                                        onClick={() =>
                                            this.setState(
                                                {
                                                    offset: 0,
                                                    pageIndex: 1,
                                                    periodicalTitleFilter: this.state.periodicalTitleFilterTemp,
                                                    periodicityFilter: this.state.periodicityFilterTemp,
                                                    categoryFilter: this.state.categoryFilterTemp,
                                                    periodicalDeleteStatus: this.state.statusFilterTemp,
                                                    iidFilter: this.state.iidFilterTemp,
                                                    selectedPeriodicalds: []
                                                },
                                                () => this.getPeriodicalList()
                                            )
                                        }
                                    >
                                        <span className="fs-12">Apply</span>
                                    </button>
                                    <button
                                        type="button"
                                        style={{ fontSize: "12px", padding: "10px 16px" }}
                                        className="btn btn-outline-primary br-5 btn-lg"
                                        onClick={() => this.clearFilter()}
                                    >
                                        <span className="fs-12">Clear</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className='d-flex col-md px-0 mt-4 justify-content-end'>
                            {/* <span className='actionBox'>
                                <div>
                                    <ImportSubscription
                                        export={this.subscriptionTableToCSV}
                                    />
                                </div>
                                <FontAwesomeIcon size='sm' style={{ color: '#0465AC' }} icon={["fa", "file-import"]} />
                            </span> */}
                            <span className='refreshBox' style={{ height: '40px' }}>
                                <FontAwesomeIcon size='sm' onClick={() => this.clearFilter()} style={{ color: '#3D5566', cursor: 'pointer' }} icon={["fa", "redo"]} />
                            </span>
                            <div style={{ display: 'none' }}>
                                <ReactHTMLTableToExcel
                                    id="expenseExport"
                                    className="btn outline-button waves-effect text-capitalize"
                                    table='expenseTable'
                                    filename="Periodicals/ Journals List"
                                    sheet="tablexls"
                                    buttonText="Export to Excel"
                                />
                            </div>
                            <span className='actionBox' style={{ height: '40px' }} title="Click here to export" type="button" id="expensesButton" onClick={() => {
                                this.setState({ dataHideWhileExporting: false }, () => {
                                    this.exportExpenseDetails()
                                })
                            }}
                            // onClick={() => this.exportExpenseDetails()}
                            >
                                <FontAwesomeIcon size='sm' style={{ color: '#0465AC' }} icon={["fa", "file-export"]} />
                            </span>
                            {/* <span className='actionBox'>
                                <div>
                                    <ImportPeriodicals
                                        export={this.tableToCSV}
                                    />
                                </div>
                                <FontAwesomeIcon size='sm' style={{ color: '#0465AC' }} icon={["fa", "file-import"]} />
                            </span> */}
                            <div>
                                <button className="btn outline-button rounded" id='dropdownMenuButton' data-toggle="dropdown">
                                    <FontAwesomeIcon icon={['fas', 'file-download']} size="lg" style={{ marginRight: 5 }} />
                                    Import
                                </button>
                                <div class="dropdown-menu p-3" aria-labelledby="dropdownMenuButton">
                                    <p style={{ fontSize: 16, cursor: 'pointer', marginBottom: '12px' }} title='Click to import periodicals' onClick={() => {
                                        this.setState({
                                            isShowImportPeriodicalButton: true
                                        });
                                    }}>
                                        <FontAwesomeIcon size='lg' style={{ color: '#0465AC', cursor: 'pointer' }} title="Click here to import periodicals" icon={["fa", "file-import"]} /> Import Periodicals
                                    </p>
                                    <p style={{ fontSize: 16, cursor: 'pointer' }} title='Click to import subscription' onClick={() => {
                                        this.setState({
                                            isShowImportSubscriptionButton: true
                                        });
                                    }}>
                                        <FontAwesomeIcon size='lg' style={{ color: '#0465AC', cursor: 'pointer' }} title="Click here to import periodicals" icon={["fa", "file-import"]} /> Import Subscription
                                    </p>
                                </div>
                            </div>
                            <button type="button" onClick={() => this.addOrEditPeriodicalModal()} style={{ fontSize: '10px !important', padding: '5px 10px !important' }} className="btn btn-primary br-5">
                                <FontAwesomeIcon size='sm' icon={["fa", "plus"]} /> &nbsp;
                                <span className='fs-13'>Add Periodicals/ Journals</span>
                            </button>
                        </div>
                    </div >
                    <div className='col-md-12 pl-0 mt-4 pr-4'>
                        <div className="table-responsive custom-scrollbar" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                            <table class="table table-sm table-bordered table-responsive-sm" id='expenseTable'>
                                <thead style={{ backgroundColor: "#f2f3f4", position: 'sticky', top: '-1%' }}>
                                    <tr>
                                        {this.state.dataHideWhileExporting &&
                                            <th>
                                                <input
                                                    type="checkbox"
                                                    checked={Object.keys(this.state.periodicalAllData).length > 0 && (Object.keys(this.state.periodicalAllData).length == this.state.selectedPeriodicalds.length)}
                                                    onChange={(e) => this.selectAllPeriodicals(e)}
                                                    style={{ marginRight: 5 }}
                                                />
                                            </th>
                                        }
                                        <th scope="col">Sr.No.</th>
                                        <th scope="col">Institute</th>
                                        <th scope="col">Title</th>
                                        <th scope="col">ISSN Number</th>
                                        <th scope="col">Accession Series</th>
                                        <th scope="col">Accession Number</th>
                                        <th scope="col">Category</th>
                                        <th scope="col">No. of Copies</th>
                                        <th scope="col">Periodicity</th>
                                        <th scope="col">Department</th>
                                        <th scope="col">No. of Subscription</th>
                                        <th scope="col">Average Price Per Copy</th>
                                        <th scope="col">Latest Added Periodical Copy Price</th>
                                        <th scope="col">Publisher</th>
                                        <th scope="col">Last Modified By</th>
                                        {/* <th scope="col">Action</th> */}
                                    </tr>

                                    {
                                        this.state.selectedPeriodicalds.length > 0 &&
                                        <tr style={{ backgroundColor: "#eff7ff" }}>
                                            <th colSpan="14" style={{ padding: '10px' }}>
                                                <div className="">
                                                    <span id="renewMembership" title="Mark as active" onClick={() => this.checkDeleteAccess('active')}>
                                                        Active
                                                    </span>
                                                    <span id="renewMembership" title="Mark as inactive" onClick={() => this.checkDeleteAccess('inactive')}>
                                                        Inactive
                                                    </span>
                                                </div>
                                            </th>
                                        </tr>
                                    }

                                </thead>
                                <tbody>
                                    {
                                        this.state.periodicalListLoading ?
                                            <tr>
                                                {/* <Spinner /> */}
                                                <ButtonLoader />
                                            </tr>
                                            :
                                            this.state.sortedIdArray.length > 0 ?
                                                this.state.sortedIdArray.map((periodicalId, index) => {
                                                    let periodical = this.state.periodicalAllData[periodicalId];
                                                    let periodicity = periodical.periodicity.charAt(0).toUpperCase() + periodical.periodicity.slice(1);

                                                    switch (periodical.periodicity) {
                                                        case 'bimonthly':
                                                            periodicity = 'Bi Monthly';
                                                            break;
                                                        case 'half yearly':
                                                            periodicity = 'Half yearly';
                                                            break;
                                                        case 'tri annually':
                                                            periodicity = 'Tri Annually';
                                                            break;
                                                        default:
                                                            break;
                                                    }

                                                    return (
                                                        <tr>
                                                            {this.state.dataHideWhileExporting &&
                                                                <th style={{ padding: '0.5rem' }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={this.state.selectedPeriodicalds.includes(periodical.periodicalUID.toString())}
                                                                        onChange={() => this.selectSinglePeriodical(periodical.periodicalUID.toString())}
                                                                        style={{ marginRight: 5 }}
                                                                    />
                                                                </th>
                                                            }
                                                            <td scope="row">{this.state.offset + index + 1}</td>
                                                            <td>{periodical.periodicalInstituteName}</td>
                                                            <td className='wrap-tableText' style={{ color: '#2979FF', fontWeight: '500', cursor: 'pointer' }}
                                                                onClick={() => this.setState({ editPeriodicalIID: periodical.periodicalIID }, () => {
                                                                    this.getEditPublisherList();
                                                                    this.getEditAccessionSeries();
                                                                    this.getEditCategory();
                                                                    this.getEditDepartment();

                                                                    setTimeout(() => {
                                                                        this.getPeriodicalUpdateDetails(periodical);
                                                                    }, 1000);
                                                                })}
                                                            >
                                                                {periodical.title}</td>
                                                            <td>{periodical.ISSN}</td>
                                                            <td>{periodical.accessionSeriesText}</td>
                                                            <td>{periodical.accessionNumber}</td>
                                                            <td>{periodical.periodicalCategoryName}</td>
                                                            <td style={{ color: '#2979FF', fontWeight: '600', cursor: 'pointer' }} onClick={() => this.props.getDailyLogDetails(periodicalId)}>{periodical.totalNumberOfIssues}</td>
                                                            <td>{periodicity}</td>
                                                            <td className='wrap-tableText'>{periodical.Department.join(', ')}</td>
                                                            <td onClick={() => this.openSubscriptionModal(periodical.periodicalUID, periodical.subscriptions, periodical.title, periodical.periodicalIID)} style={{ color: '#2979FF', fontWeight: '600', cursor: 'pointer' }}>{periodical.subscriptions.length != 0 ? periodical.subscriptions.length : '-'}</td>
                                                            <td>{this.state.dataHideWhileExporting && <>₹</>}{periodical.avgPricePerCopy.toFixed(2)}</td>
                                                            <td>{<>₹</>}{periodical.lastPricePerCopy ? periodical.lastPricePerCopy.toFixed(2) : 0}</td>                                                           
                                                            <td>{periodical.publisher}</td>
                                                            <td style={{ padding: "5px", cursor: "pointer", color: periodical.periodicalUID == this.state.hoverID ? "#0465AC" : "" }}
                                                                onMouseEnter={() => this.setState({ hoverID: periodical.periodicalUID })}
                                                                onMouseLeave={() => this.setState({ hoverID: "" })}
                                                                onClick={() => this.openActivitySlider(periodical.periodicalUID)}>
                                                                {periodical.updated_by_Name ? (
                                                                    <div className="d-flex flex-column">
                                                                        <div>{periodical.updated_by_Name} ({periodical.last_updated_by_ERP}) | {periodical.updatedOn}</div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="d-flex flex-column">
                                                                        <div>{periodical.added_by_name} ({periodical.added_by_ERP}) | {periodical.addedOn}</div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            {/* <td className=''>
                                                                &nbsp;<span><FontAwesomeIcon style={{ color: '#3D5566', cursor: 'pointer' }} icon={["fa", "pencil-alt"]} onClick={() => this.getPeriodicalUpdateDetails(periodical)} /></span>&nbsp;&nbsp;&nbsp;&nbsp;
                                                                <span><FontAwesomeIcon style={{ color: '#3D5566', cursor: 'pointer' }} icon={["fa", "trash-alt"]} onClick={() => this.checkDeleteAccess(periodical.periodicalUID)} /></span>
                                                            </td> */}
                                                        </tr>
                                                    )
                                                })
                                                :
                                                <tr><td colSpan={12}>No periodicals added.</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="pl-3 pr-4">
                            {
                                Object.keys(this.state.periodicalAllData).length > 0 &&
                                <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15 }}>
                                    <div className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold" }}>
                                        <span >Show</span>
                                        <select
                                            className="mx-2"
                                            value={this.state.limit}
                                            onChange={(e) => this.selectLimit(e)}
                                        >
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                            <option value={40}>40</option>
                                            <option value={100}>100</option>
                                            <option value={250}>250</option>
                                        </select>
                                        <span>entries</span>
                                    </div>

                                    <div id="paginationContainer">
                                        <Pagination
                                            activePage={this.state.pageIndex}
                                            itemsCountPerPage={this.state.limit}
                                            totalItemsCount={this.state.totalRecords}
                                            pageRangeDisplayed={3}
                                            onChange={(num) => this.updatePaginationCount(num)}
                                        />
                                    </div>

                                    <p className="mx-2" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records : {this.state.totalRecords} </p>
                                </div>
                            }
                        </div>
                    </div>
                </div >

                {/* Modal to Periodical Category */}
                < div className={this.state.addCategoryModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                    <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '41VW', minHeight: "calc(100% - 13.5rem)" }}>
                        <div class="modal-content">
                            <div class="modal-header" style={{ padding: '15px' }}>
                                <h5 class="modal-title">Periodical Category</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" onClick={() => this.closeCategoryModal()}>&times;</span>
                                </button>
                            </div>
                            <div class="modal-body pl-0 pr-0">
                                <div className='col-md-12'>
                                    {/* <label className='fs-13 fieldHeadColor '>Periodical Category</label> */}
                                    <div className='d-flex mb-3'>
                                        <div className='col-md-4 pl-0'>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <Select
                                                    options={Object.values(this.state.multipleInstituteDetails).map(item => ({
                                                        value: item.iid,
                                                        label: item.institute_name,
                                                    }))}
                                                    value={this.state.resourceCategoryIID}
                                                    className="basic-multi-select-filter"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            resourceCategoryIID: event || [], // Handle empty selection                                          
                                                        }
                                                        );
                                                    }}
                                                    placeholder="Select Institute"
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            width: '100%',
                                                            minHeight: 42, // Minimum height for the control area
                                                            height: 'auto', // Allow control to grow dynamically
                                                        }),
                                                        menu: (base) => ({
                                                            ...base,
                                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                                        }),
                                                        menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                        }),
                                                        placeholder: (base) => ({
                                                            ...base,
                                                            fontSize: '12px',
                                                            fontWeight: 400,
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            fontSize: '12px',
                                                            fontWeight: 400,
                                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                            color: state.isSelected ? '#333' : '#555',
                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            fontSize: '12px',
                                                            fontWeight: '400',
                                                        }),
                                                    }}
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </div>
                                        <div className='mr-2 mt-1'>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Periodical Category"
                                                value={this.state.periodicalCategory}
                                                onChange={(e) => this.setState({ periodicalCategory: e.target.value })}
                                            />
                                        </div>
                                        <div className=''>
                                            <button style={{ fontSize: '13px !important', paddingTop: '5px', paddingBottom: '6px' }}
                                                className="btn btn-primary px-3 br-5"
                                                disabled={this.state.periodicalCategory == ""}
                                                onClick={() => this.apiCallToAddPeriodicalCategory()}
                                            ><span className='fs-13'>Add</span></button>
                                            <button style={{ fontSize: '12px !important' }} className="btn btn-outline-primary waves-effect px-2 py-1 br-5" onClick={() => this.closeCategoryModal()}><span className='fs-12'>Cancel</span></button>
                                        </div>
                                    </div>
                                    <div className="table-responsive scroll-Category">
                                        <table class="table table-sm table-bordered table-responsive-sm">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Sr.No.</th>
                                                    <th scope="col">Institute</th>
                                                    <th scope="col">Category Name</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    Object.keys(this.state.periodicalCategoryList).length > 0 ?
                                                        Object.values(this.state.periodicalCategoryList).map((categoryId, index) => {

                                                            return (
                                                                <>
                                                                    <tr key={categoryId}>
                                                                        <th scope="row">{index + 1}</th>
                                                                        <th scope="row">{categoryId.periodicalCategory_InstituteName}</th>
                                                                        <td>
                                                                            {
                                                                                this.state.editingCategoryId === categoryId.uniqueid ?
                                                                                    <div className='d-flex'>
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control"
                                                                                            style={{ fontSize: '14px' }}
                                                                                            placeholder="Enter Periodical Category"
                                                                                            value={this.state.editedCategoryName}
                                                                                            onChange={(e) => this.setState({ editedCategoryName: e.target.value })}
                                                                                        />
                                                                                        <span className='ml-2'><FontAwesomeIcon
                                                                                            style={{ color: 'green', cursor: 'pointer' }}
                                                                                            onClick={() => this.setState({ categoryDetails: categoryId, editingCategoryId: categoryId.uniqueid }, () => this.apiCallToUpdatePeriodicalCategory())}
                                                                                            icon={["fa", "check"]}
                                                                                        /></span>&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                        <span><FontAwesomeIcon
                                                                                            style={{ color: 'red', cursor: 'pointer' }}
                                                                                            onClick={() => this.setState({ editingCategoryId: null, editedCategoryName: '' })}
                                                                                            icon={["fa", "times"]}
                                                                                        /></span>
                                                                                    </div>
                                                                                    :
                                                                                    categoryId.category_name
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            &nbsp;<span><FontAwesomeIcon
                                                                                style={{ color: '#3D5566', cursor: 'pointer' }}
                                                                                onClick={() => {
                                                                                    const editGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['periodicals'].find(access => access === 'edit');

                                                                                    if (editGrantAccess !== undefined) {
                                                                                        this.setState({ editingCategoryId: categoryId.uniqueid, editedCategoryName: categoryId.category_name })
                                                                                    }
                                                                                    else {
                                                                                        this.setState({
                                                                                            successModal: true,
                                                                                            successModalType: 'warning',
                                                                                            successMessage: 'This operation is restricted by the Library admin.'
                                                                                        });
                                                                                    }
                                                                                }
                                                                                }
                                                                                icon={["fa", "pencil-alt"]}
                                                                            /></span>&nbsp;&nbsp;&nbsp;&nbsp;
                                                                            <span><FontAwesomeIcon
                                                                                style={{ color: '#3D5566', cursor: 'pointer' }}
                                                                                onClick={() => this.deletePeriodicalCategory(categoryId.uniqueid, categoryId.periodicalCategoryIID)}
                                                                                icon={["fa", "trash-alt"]}
                                                                            /></span>
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            )
                                                        })
                                                        :
                                                        <tr><td colSpan="3">No categories found.</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >

                {/* Modal to edit Subscriptions */}
                < div className={this.state.updateSubcriptionModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                    <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '55VW', minHeight: "calc(100% - 13.5rem)" }}>
                        <div class="modal-content">
                            <div class="modal-header" style={{ padding: '15px' }}>
                                <h6 class="modal-title fw-600">{this.state.priodicalTitleForModal} - Subscription Details</h6>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" onClick={() => this.closeUpdateSubcriptionModal()}>&times;</span>
                                </button>
                            </div>
                            <div class="modal-body custom-modal-body pl-0 pr-0">
                                <div className='col-md-12 pl-4'>
                                    <div className='scroll-subscriptionContainer col-md-12 pl-0 pr-0'>
                                        {
                                            this.state.subscriptions.length > 0 ?
                                                this.state.subscriptions.map((subscription, index) => (
                                                    <div key={index + 1}>
                                                        <p className='fs-16 pb-2 pt-3 fw-600' style={{ color: '#313131' }}>Subscription {index + 1}
                                                            <span className='pr-4' style={{ float: 'right' }}>
                                                                <FontAwesomeIcon icon={['fas', 'trash-alt']} className='ml-3 fieldHeadColor' onClick={() => this.functionToDeleteSubscription(subscription.subUniqueid, index + 1)} size="sm" style={{ cursor: "pointer" }} />
                                                            </span>
                                                        </p>
                                                        <div className='d-flex pb-3'>
                                                            <div className='col-md-4 pl-0'>
                                                                <label className='fs-14 fieldHeadColor '>Vendor</label>
                                                                <select className="form-control"
                                                                    style={{ fontSize: '13px' }}
                                                                    value={subscription.vendor}
                                                                    onChange={(e) => this.handleInputChange(index + 1, 'vendor', e.target.value)}
                                                                >
                                                                    <option value="">Select Vendor</option>
                                                                    {
                                                                        Object.keys(this.state.addSubVendorData).map(vendor => {
                                                                            let vendorName = this.state.addSubVendorData[vendor]

                                                                            return (
                                                                                <option style={{ fontSize: '13px' }} value={vendor}>{vendorName.displayname}</option>
                                                                            );
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>
                                                            <div className='col-md-4 pl-0'>
                                                                <label className='fs-14 fieldHeadColor '>Subscription Start Date<span className='text-danger'>*</span></label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                                    placeholder="Select Subscription Start Date"
                                                                    value={subscription.startDate}
                                                                    onChange={(e) => this.handleInputChange(index + 1, 'startDate', e.target.value)}
                                                                />
                                                                <p className='text-danger fs-12'>{subscription.startDateWarning}</p>
                                                            </div>
                                                            <div className='col-md-4 pl-0'>
                                                                <label className='fs-14 fieldHeadColor '>Subscription End Date<span className='text-danger'>*</span></label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                                    placeholder="Select Subscription End Date"
                                                                    value={subscription.endDate}
                                                                    onChange={(e) => this.handleInputChange(index + 1, 'endDate', e.target.value)}
                                                                />
                                                                <p className='text-danger fs-12'>{subscription.endDateWarning}</p>
                                                            </div>
                                                        </div>
                                                        <div className='d-flex'>
                                                            <div className='col-md-4 pl-0'>
                                                                <label className='fs-13 fieldHeadColor '>Number of Expected Issues</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                                    placeholder="Enter Number of Expected Issues"
                                                                    value={subscription.expectedIssues}

                                                                    onChange={(e) => {
                                                                        // Check if the input is a positive number
                                                                        if (/^\d+$/.test(e.target.value) || e.target.value === '') {
                                                                            this.handleInputChange(index + 1, 'expectedIssues', e.target.value)
                                                                        }
                                                                    }}

                                                                // onChange={(e) => this.handleInputChange(index + 1, 'expectedIssues', e.target.value)}
                                                                />
                                                            </div>
                                                            <div className='col-md-4 pl-0'>
                                                                <label className='fs-13 fieldHeadColor '>Average Price Per Copy<span className='text-danger'>*</span></label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                                    placeholder="Enter Average Price Per Issue"
                                                                    value={subscription.avgPricePerCopy}
                                                                    onChange={(e) => {
                                                                        // Check if the input is a positive number
                                                                        if (/^\d*\.?\d{0,3}$/.test(e.target.value) || e.target.value === '') {
                                                                            this.handleInputChange(index + 1, 'avgPricePerCopy', e.target.value)
                                                                        }
                                                                    }}
                                                                // onChange={(e) => this.handleInputChange(index + 1, 'avgPricePerCopy', e.target.value)}
                                                                />
                                                            </div>
                                                            <div className='col-md-4 pl-0'>
                                                                <label className='fs-13 fieldHeadColor '>Total Price Per Subscription</label>
                                                                <div className='d-flex justify-content-between'>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', maxWidth: '77%' }}
                                                                        value={
                                                                            (subscription.expectedIssues === '' || subscription.expectedIssues === 0)
                                                                                ? 0
                                                                                : subscription.expectedIssues * subscription.avgPricePerCopy
                                                                        }
                                                                        disabled
                                                                    />
                                                                    <input
                                                                        type="text"
                                                                        className="form-control ml-2 col"
                                                                        style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                                        disabled
                                                                        value="₹"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p className='text-danger fs-12'>{subscription.mandatoryWarning}</p>

                                                    </div>
                                                ))
                                                :
                                                <p className='pb-4'>No subscriptions added.</p>
                                        }
                                    </div>
                                    <p className='fs-14 py-3 fw-600'><span
                                        style={{
                                            color: this.isAddButtonDisabled() ? '#A0A0A0' : '#004D86',
                                            textDecoration: 'underline',
                                            cursor: this.isAddButtonDisabled() ? 'default' : 'pointer'
                                        }}
                                        onClick={!this.isAddButtonDisabled() ? this.addSubscription : null}
                                    >+ Add Subscription</span></p>
                                    <hr />
                                    <div className='d-flex col-md-12 pl-0'>
                                        <span className='col-md-8 pl-0'>Total Price (in Rs.)</span>
                                        <span className='ml-2'>
                                            <div className='d-flex justify-content-between'>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', maxWidth: '77%' }}
                                                    disabled
                                                    value={parseFloat(this.state.totalPrice).toFixed(3)}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control ml-2 col"
                                                    style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                    disabled
                                                    value="₹"
                                                />
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer pt-1">
                                <button className="btn btn-outline-primary waves-effect p-2" style={{ fontSize: '13px !important' }} onClick={() => this.closeUpdateSubcriptionModal()}><span className='fs-13'>Cancel</span></button>
                                <button className="btn btn-primary"
                                    onClick={() => this.validateSubscriptions()}
                                >Save</button>
                            </div>
                        </div>
                    </div>
                </div >

                {
                    this.returnAddPeriodical()
                }
                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
                {
                    this.state.deletePeriodical &&
                    <DeleteModal
                        showModal={this.state.deletePeriodical}
                        visibility={this.closeDeletePeriodical}
                        deleteKey='Periodical'
                        deleteComponent={this.apiCallToDeletePeriodical}
                    />
                }
                {
                    <ImportPeriodicals
                        export={this.tableToCSV}
                        accessionSeriesListData={this.state.accessionSeriesList}
                        isShowImportPeriodicalButton={this.state.isShowImportPeriodicalButton}
                        closeImportModalForPeriodicals={this.closeImportModalForPeriodicals}
                    />
                }
                {
                    <ImportSubscription
                        export={this.subscriptionTableToCSV}
                        isShowImportSubscriptionButton={this.state.isShowImportSubscriptionButton}
                        closeImportModalForSubscription={this.closeImportModalForSubscription}
                    />
                }
                {
                    this.state.showActivitySlider && this.state.selectedIid != "" &&
                    <SpecificUserLog
                        showSlider={this.state.showActivitySlider}
                        closeSlider={this.closeActivitySlider}
                        logUid={this.state.selectedIid}
                        activityArr={["periodicals_added", "periodicals_updated", "subscription_added", "logs_updated", "log_deleted" ]}
                    />
                }
            </>
        )
    }
}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray },
        multipleInstituteDetails: { ...store.RouteMenuReducer.multipleInstituteDetails }
    };
};

export default connect(mapStateToProps)(PeriodicalJournal);